import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Supported languages
export const supportedLanguages = {
  en: "English",
  hi: "हिन्दी",
  gu: "ગુજરાતી",
  es: "Español",
  fr: "Français",
  de: "Deutsch",
  ru: "Русский",
  pt: "Português",
  ja: "日本語",
  it: "Italiano",
  tr: "Türkçe",
  nl: "Nederlands",
};

// Comprehensive translations for all UI strings
const resources = {
  en: {
    translation: {
      "has clinched victory! Celebrate the win and share the result.": "has clinched victory! Celebrate the win and share the result.",
      "Both teams are tied. Get ready for a thrilling super over to decide the champion!": "Both teams are tied. Get ready for a thrilling super over to decide the champion!",
      "Finish Game": "Finish Game",
      "Start Super Over": "Start Super Over",
      "Innings Breakdown": "Innings Breakdown",
      "No events for this team yet.": "No events for this team yet.",
      // Home page
      "Home": "Home",
      "Cricket Score Counter – Free Online Live Score Tracker": "Cricket Score Counter – Free Online Live Score Tracker",
      "Effortlessly count runs, track overs, and share live cricket scores with friends. Perfect for street, club, or school matches – keep your game organized and scores accessible from any device, anywhere.": "Effortlessly count runs, track overs, and share live cricket scores with friends. Perfect for street, club, or school matches – keep your game organized and scores accessible from any device, anywhere.",
      // Footer
      "Cricket Score Counter. All rights reserved.": "Cricket Score Counter. All rights reserved.",
      "This site uses cookies and may serve ads by Google AdSense. By using this site, you agree to our policies.": "This site uses cookies and may serve ads by Google AdSense. By using this site, you agree to our policies.",
      // Disclaimer page
      "Disclaimer": "Disclaimer",
      "Disclaimer for Cricket Score Counter.": "Disclaimer for Cricket Score Counter.",
      "Cricket Score Counter is provided for informational and entertainment purposes only. We do not guarantee the accuracy or completeness of scores or match data.": "Cricket Score Counter is provided for informational and entertainment purposes only. We do not guarantee the accuracy or completeness of scores or match data.",
      "Ads and Third-Party Content": "Ads and Third-Party Content",
      "This site may display ads served by Google AdSense. We are not responsible for the content of third-party ads or external links.": "This site may display ads served by Google AdSense. We are not responsible for the content of third-party ads or external links.",
      "Limitation of Liability": "Limitation of Liability",
      "We are not liable for any damages resulting from the use of this site.": "We are not liable for any damages resulting from the use of this site.",
      // Privacy Policy page
      "Privacy Policy": "Privacy Policy",
      "Privacy Policy for Cricket Score Counter.": "Privacy Policy for Cricket Score Counter.",
      "This Privacy Policy explains how Cricket Score Counter collects, uses, and protects your information.": "This Privacy Policy explains how Cricket Score Counter collects, uses, and protects your information.",
      "Information Collection": "Information Collection",
      "We may collect non-personal information such as browser type, device, and usage statistics. We do not collect personal information unless you provide it voluntarily.": "We may collect non-personal information such as browser type, device, and usage statistics. We do not collect personal information unless you provide it voluntarily.",
      "Cookies and Ads": "Cookies and Ads",
      "We use cookies to improve your experience. We may serve ads by Google AdSense, which may use cookies to personalize ads.": "We use cookies to improve your experience. We may serve ads by Google AdSense, which may use cookies to personalize ads.",
      "Third-Party Services": "Third-Party Services",
      "We may use third-party services such as Google Analytics and AdSense. These services may collect and use information according to their own policies.": "We may use third-party services such as Google Analytics and AdSense. These services may collect and use information according to their own policies.",
      "Your Consent": "Your Consent",
      "By using our site, you consent to our privacy policy.": "By using our site, you consent to our privacy policy.",
      "Contact": "Contact",
      "If you have questions, contact us at": "If you have questions, contact us at",
      Welcome: "Welcome",
      "Create Game": "Create Game",
      "Join Game": "Join Game",
      "Score Board": "Score Board",
      "Cricket Score Counter": "Cricket Score Counter",
      "The easiest way to score, track, and share your cricket matches live.":
        "The easiest way to score, track, and share your cricket matches live.",
      "Start a new match or join an existing one to begin scoring instantly.":
        "Start a new match or join an existing one to begin scoring instantly.",
      "Quick Match Setup": "Quick Match Setup",
      "Start a new game in seconds—no sign up needed!":
        "Start a new game in seconds—no sign up needed!",
      "Real-Time Scoring": "Real-Time Scoring",
      "Update scores ball-by-ball and see instant results.":
        "Update scores ball-by-ball and see instant results.",
      "Easy Sharing": "Easy Sharing",
      "Share your match link with friends and family instantly.":
        "Share your match link with friends and family instantly.",
      "Enter Game ID": "Enter Game ID",
      "Game ID": "Game ID",
      "Game ID is required": "Game ID is required",
      Cancel: "Cancel",
      "View Score": "View Score",
      "Team 1 Name": "Team 1 Name",
      "Team 2 Name": "Team 2 Name",
      "Number of Overs": "Number of Overs",
      "Please enter both team names.": "Please enter both team names.",
      "Please enter a valid number of overs (1-50).":
        "Please enter a valid number of overs (1-50).",
      "Enter Team Names": "Enter Team Names",
      "INDIA A": "INDIA A",
      "INDIA B": "INDIA B",
      "Team 1": "Team 1",
      "Team 2": "Team 2",
      "will flip the coin": "will flip the coin",
      "will select Heads or Tails": "will select Heads or Tails",
      Heads: "Heads",
      Tails: "Tails",
      "Select Heads or Tails first": "Select Heads or Tails first",
      "Click to flip coin": "Click to flip coin",
      "Tap the coin to flip": "Tap the coin to flip",
      "Select Heads or Tails to enable coin":
        "Select Heads or Tails to enable coin",
      "Coin Flip Result:": "Coin Flip Result:",
      "won the toss!": "won the toss!",
      "Bat First": "Bat First",
      "Ball First": "Ball First",
      "Start Match": "Start Match",
      "Go with Toss": "Go with Toss",
      "Copy Game ID": "Copy Game ID",
      "Share Game": "Share Game",
      "End Inning": "End Inning",
      "End Game": "End Game",
      "View History": "View History",
      "Reset Game": "Reset Game",
      "Game ID copied!": "Game ID copied!",
      "End Inning?": "End Inning?",
      "End Game?": "End Game?",
      "Are you sure you want to end the current inning? This action cannot be undone.":
        "Are you sure you want to end the current inning? This action cannot be undone.",
      "Are you sure you want to end the game? This will reset all progress.":
        "Are you sure you want to end the game? This will reset all progress.",
      Yes: "Yes",
      "Congratulations!": "Congratulations!",
      "wins the match!": "wins the match!",
      "It's a Tie! Super Over Time!": "It's a Tie! Super Over Time!",
      "Restart Match?": "Restart Match?",
      "This will clear your current match.":
        "This will clear your current match.",
      "Enter overs for the new match:": "Enter overs for the new match:",
      Overs: "Overs",
      Restart: "Restart",
      "Set Number of Overs": "Set Number of Overs",
      "How many overs will this match have?":
        "How many overs will this match have?",
      "Set Overs": "Set Overs",
      "Target Ready!": "Target Ready!",
      needs: "needs",
      "runs to win": "runs to win",
      "First innings complete. Start the chase when you’re ready.":
        "First innings complete. Start the chase when you’re ready.",
      "Begin Chase": "Begin Chase",
    },
  },
  hi: {
    translation: {
      "has clinched victory! Celebrate the win and share the result.": "ने जीत हासिल की है! जीत का जश्न मनाएं और परिणाम साझा करें।",
      "Both teams are tied. Get ready for a thrilling super over to decide the champion!": "दोनों टीमें बराबरी पर हैं। विजेता तय करने के लिए रोमांचक सुपर ओवर के लिए तैयार हो जाएं!",
      "Finish Game": "गेम समाप्त करें",
      "Start Super Over": "सुपर ओवर शुरू करें",
      "Innings Breakdown": "पारी का विवरण",
      "No events for this team yet.": "इस टीम के लिए अभी तक कोई इवेंट नहीं है।",
      // Home page
      "Home": "होम",
      "Cricket Score Counter – Free Online Live Score Tracker": "क्रिकेट स्कोर काउंटर – फ्री ऑनलाइन लाइव स्कोर ट्रैकर",
      "Effortlessly count runs, track overs, and share live cricket scores with friends. Perfect for street, club, or school matches – keep your game organized and scores accessible from any device, anywhere.": "आसानी से रन गिनें, ओवर ट्रैक करें, और दोस्तों के साथ लाइव क्रिकेट स्कोर साझा करें। गली, क्लब या स्कूल मैचों के लिए परफेक्ट – अपने गेम को व्यवस्थित रखें और स्कोर किसी भी डिवाइस से, कहीं भी एक्सेस करें।",
      // Footer
      "Cricket Score Counter. All rights reserved.": "क्रिकेट स्कोर काउंटर। सर्वाधिकार सुरक्षित।",
      "This site uses cookies and may serve ads by Google AdSense. By using this site, you agree to our policies.": "यह साइट कुकीज़ का उपयोग करती है और Google AdSense द्वारा विज्ञापन दिखा सकती है। इस साइट का उपयोग करके, आप हमारी नीतियों से सहमत होते हैं।",
      // Disclaimer page
      "Disclaimer": "अस्वीकरण",
      "Disclaimer for Cricket Score Counter.": "क्रिकेट स्कोर काउंटर के लिए अस्वीकरण।",
      "Cricket Score Counter is provided for informational and entertainment purposes only. We do not guarantee the accuracy or completeness of scores or match data.": "क्रिकेट स्कोर काउंटर केवल सूचना और मनोरंजन के लिए प्रदान किया गया है। हम स्कोर या मैच डेटा की सटीकता या पूर्णता की गारंटी नहीं देते।",
      "Ads and Third-Party Content": "विज्ञापन और तृतीय-पक्ष सामग्री",
      "This site may display ads served by Google AdSense. We are not responsible for the content of third-party ads or external links.": "यह साइट Google AdSense द्वारा प्रदत्त विज्ञापन दिखा सकती है। हम तृतीय-पक्ष विज्ञापनों या बाहरी लिंक की सामग्री के लिए जिम्मेदार नहीं हैं।",
      "Limitation of Liability": "दायित्व की सीमा",
      "We are not liable for any damages resulting from the use of this site.": "इस साइट के उपयोग से उत्पन्न किसी भी क्षति के लिए हम उत्तरदायी नहीं हैं।",
      // Privacy Policy page
      "Privacy Policy": "गोपनीयता नीति",
      "Privacy Policy for Cricket Score Counter.": "क्रिकेट स्कोर काउंटर के लिए गोपनीयता नीति।",
      "This Privacy Policy explains how Cricket Score Counter collects, uses, and protects your information.": "यह गोपनीयता नीति बताती है कि क्रिकेट स्कोर काउंटर आपकी जानकारी कैसे एकत्र, उपयोग और सुरक्षित करता है।",
      "Information Collection": "जानकारी संग्रहण",
      "We may collect non-personal information such as browser type, device, and usage statistics. We do not collect personal information unless you provide it voluntarily.": "हम ब्राउज़र प्रकार, डिवाइस और उपयोग सांख्यिकी जैसी गैर-व्यक्तिगत जानकारी एकत्र कर सकते हैं। हम व्यक्तिगत जानकारी तब तक एकत्र नहीं करते जब तक आप स्वेच्छा से न दें।",
      "Cookies and Ads": "कुकीज़ और विज्ञापन",
      "We use cookies to improve your experience. We may serve ads by Google AdSense, which may use cookies to personalize ads.": "हम आपके अनुभव को बेहतर बनाने के लिए कुकीज़ का उपयोग करते हैं। हम Google AdSense द्वारा विज्ञापन दिखा सकते हैं, जो विज्ञापनों को वैयक्तिकृत करने के लिए कुकीज़ का उपयोग कर सकते हैं।",
      "Third-Party Services": "तृतीय-पक्ष सेवाएँ",
      "We may use third-party services such as Google Analytics and AdSense. These services may collect and use information according to their own policies.": "हम Google Analytics और AdSense जैसी तृतीय-पक्ष सेवाओं का उपयोग कर सकते हैं। ये सेवाएँ अपनी नीतियों के अनुसार जानकारी एकत्र और उपयोग कर सकती हैं।",
      "Your Consent": "आपकी सहमति",
      "By using our site, you consent to our privacy policy.": "हमारी साइट का उपयोग करके, आप हमारी गोपनीयता नीति से सहमत होते हैं।",
      "Contact": "संपर्क करें",
      "If you have questions, contact us at": "यदि आपके कोई प्रश्न हैं, तो हमसे संपर्क करें",
      Welcome: "स्वागत है",
      "Create Game": "गेम बनाएं",
      "Join Game": "गेम जॉइन करें",
      "Score Board": "स्कोर बोर्ड",
      "Cricket Score Counter": "क्रिकेट स्कोर काउंटर",
      "The easiest way to score, track, and share your cricket matches live.":
        "क्रिकेट मैचों का स्कोर, ट्रैक और साझा करने का सबसे आसान तरीका।",
      "Start a new match or join an existing one to begin scoring instantly.":
        "नया मैच शुरू करें या मौजूदा में शामिल हों और तुरंत स्कोरिंग शुरू करें।",
      "Quick Match Setup": "त्वरित मैच सेटअप",
      "Start a new game in seconds—no sign up needed!":
        "कुछ ही सेकंड में नया गेम शुरू करें—साइन अप की आवश्यकता नहीं!",
      "Real-Time Scoring": "रीयल-टाइम स्कोरिंग",
      "Update scores ball-by-ball and see instant results.":
        "हर बॉल पर स्कोर अपडेट करें और तुरंत परिणाम देखें।",
      "Easy Sharing": "आसान साझा करें",
      "Share your match link with friends and family instantly.":
        "अपने मैच का लिंक तुरंत दोस्तों और परिवार के साथ साझा करें।",
      "Enter Game ID": "गेम आईडी दर्ज करें",
      "Game ID": "गेम आईडी",
      "Game ID is required": "गेम आईडी आवश्यक है",
      Cancel: "रद्द करें",
      "View Score": "स्कोर देखें",
      "Team 1 Name": "टीम 1 का नाम",
      "Team 2 Name": "टीम 2 का नाम",
      "Number of Overs": "ओवरों की संख्या",
      "Please enter both team names.": "कृपया दोनों टीमों के नाम दर्ज करें।",
      "Please enter a valid number of overs (1-50).":
        "कृपया 1-50 के बीच वैध ओवरों की संख्या दर्ज करें।",
      "Enter Team Names": "टीम के नाम दर्ज करें",
      "INDIA A": "इंडिया A",
      "INDIA B": "इंडिया B",
      "Team 1": "टीम 1",
      "Team 2": "टीम 2",
      "Players": "खिलाड़ी",
      "Team 1 Players": "टीम 1 खिलाड़ी",
      "Team 2 Players": "टीम 2 खिलाड़ी",
      "Add player": "खिलाड़ी जोड़ें",
      "Add Players": "खिलाड़ी जोड़ें",
      "Done": "पूर्ण",
      "Player": "खिलाड़ी",
      "Batting": "बैटिंग",
      "Bowling": "बॉलिंग",
      "Over": "ओवर",
      "Runs": "रन",
      "Wickets": "विकेट",
      "SR": "स्ट्राइक रेट",
      "Econ": "इकोनॉमी",
      "will flip the coin": "सिक्का उछालेंगे",
      "will select Heads or Tails": "हेड्स या टेल्स चुनेंगे",
      Heads: "हेड्स",
      Tails: "टेल्स",
      "Select Heads or Tails first": "पहले हेड्स या टेल्स चुनें",
      "Click to flip coin": "सिक्का उछालने के लिए क्लिक करें",
      "Tap the coin to flip": "सिक्का उछालने के लिए टैप करें",
      "Select Heads or Tails to enable coin":
        "सिक्का सक्षम करने के लिए हेड्स या टेल्स चुनें",
      "Coin Flip Result:": "सिक्का परिणाम:",
      "won the toss!": "ने टॉस जीता!",
      "Bat First": "पहले बल्लेबाजी",
      "Ball First": "पहले गेंदबाजी",
      "Start Match": "मैच शुरू करें",
      "Go with Toss": "टॉस के साथ जाएं",
      "Copy Game ID": "गेम आईडी कॉपी करें",
      "Share Game": "गेम साझा करें",
      "End Inning": "पारी समाप्त करें",
      "End Game": "गेम समाप्त करें",
      "View History": "इतिहास देखें",
      "Reset Game": "गेम रीसेट करें",
      "Game ID copied!": "गेम आईडी कॉपी हो गई!",
      "End Inning?": "पारी समाप्त करें?",
      "End Game?": "गेम समाप्त करें?",
      "Are you sure you want to end the current inning? This action cannot be undone.":
        "क्या आप वाकई वर्तमान पारी समाप्त करना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।",
      "Are you sure you want to end the game? This will reset all progress.":
        "क्या आप वाकई गेम समाप्त करना चाहते हैं? इससे सभी प्रगति रीसेट हो जाएगी।",
      Yes: "हाँ",
      "Congratulations!": "बधाई हो!",
      "wins the match!": "मैच जीतता है!",
      "It's a Tie! Super Over Time!": "मैच टाई! सुपर ओवर का समय!",
      "Restart Match?": "क्या आप मैच रीस्टार्ट करना चाहते हैं?",
      "This will clear your current match.":
        "यह आपके वर्तमान मैच को साफ़ कर देगा।",
      "Enter overs for the new match:": "नए मैच के लिए ओवर दर्ज करें:",
      Overs: "ओवर",
      Restart: "रीस्टार्ट",
      "Set Number of Overs": "ओवरों की संख्या सेट करें",
      "How many overs will this match have?": "इस मैच में कितने ओवर होंगे?",
      "Set Overs": "ओवर सेट करें",
      "Target Ready!": "लक्ष्य तैयार!",
      needs: "जरूरत है",
      "runs to win": "रनों की आवश्यकता",
      "First innings complete. Start the chase when you’re ready.":
        "पहली पारी पूरी। जब आप तैयार हों तो पीछा शुरू करें।",
      "Join": "जॉइन करें",
      "Contact Support": "सहायता से संपर्क करें",
      "Need help?": "मदद चाहिए?",
      "Next": "अगला",
      "Close": "बंद करें",
      "Confirm": "पुष्टि करें",
      "Continue": "जारी रखें",
      "More": "और",
      "Undo": "पूर्ववत करें",
      "3 runs": "3 रन",
      "Wide + {{runs}} runs": "वाइड + {{runs}} रन",
      "Run Out + 1 run": "रन आउट + 1 रन",
      "Run Out + 2 runs": "रन आउट + 2 रन",
      "Run Out + 3 runs": "रन आउट + 3 रन",
      "Wicket Details": "विकेट विवरण",
      "Which batsman is out?": "कौन सा बल्लेबाज़ आउट है?",
      "Wicket type": "विकेट प्रकार",
      "Bowled": "बोल्ड",
      "Catch": "कैच",
      "Run Out": "रन आउट",
      "Caught by {{name}}": "{{name}} द्वारा कैच",
      "Run out by {{name}}": "{{name}} द्वारा रन आउट",
      "Select new batsman": "नया बल्लेबाज़ चुनें",
      "No available incoming batsman left.": "कोई नया उपलब्ध बल्लेबाज़ नहीं बचा।",
      "Please select a bowler.": "कृपया गेंदबाज़ चुनें।",
      "Same bowler cannot bowl the next over.": "एक ही गेंदबाज़ लगातार अगला ओवर नहीं डाल सकता।",
      "Select Next Bowler": "अगला गेंदबाज़ चुनें",
      "Over completed. Choose bowler for next over.":
        "ओवर पूरा हुआ। अगले ओवर के लिए गेंदबाज़ चुनें।",
      "Select Opening Players": "ओपनिंग खिलाड़ी चुनें",
      "Opening Striker": "ओपनिंग स्ट्राइकर",
      "Opening Non-Striker": "ओपनिंग नॉन-स्ट्राइकर",
      "Opening Bowler": "ओपनिंग गेंदबाज़",
      "Start Scoring": "स्कोरिंग शुरू करें",
      "Player Scorecard": "प्लेयर स्कोरकार्ड",
      "Scorecard": "स्कोरकार्ड",
      "Player Preferences": "प्लेयर प्रेफरेंसेस",
      "Manage Players": "प्लेयर प्रबंधन",
      "Change Bowler": "गेंदबाज़ बदलें",
      "Track individual match stats (batting and bowling) for this match only.":
        "इस मैच के लिए व्यक्तिगत आँकड़े (बैटिंग और बॉलिंग) ट्रैक करें।",
      "1st Inning": "पहली पारी",
      "2nd Inning": "दूसरी पारी",
      "Status": "स्थिति",
      "Not out": "नाबाद",
      "out": "आउट",
      "Match History": "मैच इतिहास",
      "Match history": "मैच इतिहास",
      "What is match history?": "मैच इतिहास क्या है?",
      "Match history shows all runs, wickets, and events for each over.":
        "मैच इतिहास हर ओवर के सभी रन, विकेट और घटनाएं दिखाता है।",
      "Reviewing history helps teams analyze performance and key moments.":
        "इतिहास देखने से टीमें प्रदर्शन और अहम पलों का विश्लेषण कर सकती हैं।",
      "Use this feature to settle disputes or relive exciting plays!":
        "विवाद सुलझाने या रोमांचक पल फिर से देखने के लिए इस फीचर का उपयोग करें!",
      "Team bowling": "टीम गेंदबाज़ी",
      "{{team}} (team)": "{{team}} (टीम)",
      "Game link copied to clipboard!": "गेम लिंक क्लिपबोर्ड पर कॉपी हो गया!",
      "Error copying game link. Please copy manually: ":
        "लिंक कॉपी करने में त्रुटि। कृपया मैन्युअली कॉपी करें: ",
      "Failed to copy link. Please copy manually.":
        "लिंक कॉपी नहीं हुआ। कृपया मैन्युअली कॉपी करें।",
      "Please add at least {{count}} players for each team.":
        "कृपया प्रत्येक टीम के लिए कम से कम {{count}} खिलाड़ी जोड़ें।",
      "Player name is required.": "खिलाड़ी का नाम आवश्यक है।",
      "Player already exists.": "खिलाड़ी पहले से मौजूद है।",
      "Detailed scorecard is not available for this match.": "इस मैच के लिए विस्तृत स्कोरकार्ड उपलब्ध नहीं है।",
      "Enter player name": "खिलाड़ी का नाम दर्ज करें",
      "How to Set Up Your Cricket Match:": "अपना क्रिकेट मैच कैसे सेट करें:",
      "Enter unique team names for both sides.":
        "दोनों टीमों के लिए अलग-अलग नाम दर्ज करें।",
      "Choose the number of overs (1-50) for your match.":
        "अपने मैच के लिए ओवरों की संख्या (1-50) चुनें।",
      "Optionally, use the toss feature to decide who bats or bowls first.":
        "वैकल्पिक रूप से, टॉस फीचर से तय करें कि पहले बैटिंग या बॉलिंग कौन करेगा।",
      "Click \"Start Match\" to begin scoring live.":
        "\"मैच शुरू करें\" पर क्लिक करके लाइव स्कोरिंग शुरू करें।",
      "Cricket Match FAQ:": "क्रिकेट मैच FAQ:",
      "What is an over?": "ओवर क्या होता है?",
      "An over consists of 6 legal balls bowled by one bowler.":
        "एक ओवर में एक गेंदबाज़ द्वारा डाली गई 6 वैध गेंदें होती हैं।",
      "How do I score runs?": "मैं रन कैसे जोड़ूं?",
      "Use the scoring keypad to add runs, wickets, and extras ball-by-ball.":
        "रन, विकेट और एक्स्ट्रा को बॉल-बाय-बॉल जोड़ने के लिए स्कोरिंग कीपैड का उपयोग करें।",
      "Can I share my match?": "क्या मैं मैच शेयर कर सकता/सकती हूं?",
      "Yes! After setup, use the share link to invite friends and family.":
        "हाँ! सेटअप के बाद, शेयर लिंक से दोस्तों और परिवार को आमंत्रित करें।",
      "Is my data private?": "क्या मेरा डेटा निजी है?",
      "Your scores are only visible to those with your match link.":
        "आपका स्कोर केवल उन्हीं को दिखेगा जिनके पास आपका मैच लिंक है।",
      "How to Join a Cricket Match:": "क्रिकेट मैच में कैसे जुड़ें:",
      "Ask your friend or match organizer for the Game ID.":
        "अपने दोस्त या मैच आयोजक से गेम ID लें।",
      "Enter the Game ID above and click \"Join\".":
        "ऊपर गेम ID दर्ज करें और \"जॉइन\" पर क्लिक करें।",
      "View live scores, match stats, and recent events instantly.":
        "लाइव स्कोर, मैच आँकड़े और हाल की घटनाएं तुरंत देखें।",
      "Share the match link with others to let them follow along.":
        "दूसरों के साथ मैच लिंक साझा करें ताकि वे मैच फॉलो कर सकें।",
      "View live cricket scores and match details. Join a game and follow the action with Cricket Score Counter.":
        "लाइव क्रिकेट स्कोर और मैच विवरण देखें। गेम जॉइन करें और क्रिकेट स्कोर काउंटर के साथ हर एक्शन फॉलो करें।",
      "Enter your Game ID below to join a live cricket match and view scores in real time.":
        "लाइव क्रिकेट मैच जॉइन करने और रियल टाइम में स्कोर देखने के लिए नीचे गेम ID दर्ज करें।",
      "Page Not Found": "पेज नहीं मिला",
      "Sorry, the page you are looking for does not exist.":
        "क्षमा करें, जिस पेज को आप खोज रहे हैं वह मौजूद नहीं है।",
      "Please check the URL or return to the home page.":
        "कृपया URL जांचें या होम पेज पर लौटें।",
      "About Cricket Score Counter:": "क्रिकेट स्कोर काउंटर के बारे में:",
      "Track live cricket scores for any match, anywhere.":
        "किसी भी मैच का लाइव क्रिकेट स्कोर कहीं से भी ट्रैक करें।",
      "Set up your own match, invite friends, and keep score ball-by-ball.":
        "अपना मैच सेट करें, दोस्तों को आमंत्रित करें, और बॉल-बाय-बॉल स्कोर रखें।",
      "Perfect for street, club, or school games.":
        "गली, क्लब या स्कूल मैचों के लिए बिल्कुल सही।",
      "Learn more in our": "और जानें हमारे",
      "and": "और",
      "or": "या",
      "return to the home page": "होम पेज पर लौटें",
      "runs needed in": "रन चाहिए, शेष",
      "overs": "ओवर",
      "ON STRIKE": "स्ट्राइक पर",
      "CURRENT BOWLER": "वर्तमान गेंदबाज़",
      "CRR": "सीआरआर",
      "RRR": "आरआरआर",
      "R": "र",
      "B": "गेंदें",
      "O": "ओ",
      "W": "वि",
      "WD": "वाइड",
      "NB": "नो-बॉल",
      "click": "क्लिक",
      "run": "रन",
      "wicket": "विकेट",
      "wide": "वाइड",
      "Begin Chase": "पीछा शुरू करें",
    },
  },
  es: {
    translation: {
      "has clinched victory! Celebrate the win and share the result.": "¡ha conseguido la victoria! Celebra el triunfo y comparte el resultado.",
      "Both teams are tied. Get ready for a thrilling super over to decide the champion!": "Ambos equipos están empatados. Prepárate para un emocionante super over para decidir al campeón!",
      "Finish Game": "Terminar juego",
      "Start Super Over": "Comenzar Super Over",
      "Innings Breakdown": "Desglose de entradas",
      "No events for this team yet.": "Aún no hay eventos para este equipo.",
      // Home page
      "Home": "Inicio",
      "Cricket Score Counter – Free Online Live Score Tracker": "Cricket Score Counter – Rastreador de puntuación en vivo gratuito en línea",
      "Effortlessly count runs, track overs, and share live cricket scores with friends. Perfect for street, club, or school matches – keep your game organized and scores accessible from any device, anywhere.": "Cuenta carreras fácilmente, sigue los overs y comparte puntuaciones de cricket en vivo con amigos. Perfecto para partidos de calle, club o escuela: mantén tu juego organizado y los puntajes accesibles desde cualquier dispositivo, en cualquier lugar.",
      // Footer
      "Cricket Score Counter. All rights reserved.": "Cricket Score Counter. Todos los derechos reservados.",
      "This site uses cookies and may serve ads by Google AdSense. By using this site, you agree to our policies.": "Este sitio utiliza cookies y puede mostrar anuncios de Google AdSense. Al usar este sitio, usted acepta nuestras políticas.",
      // Disclaimer page
      "Disclaimer": "Descargo de responsabilidad",
      "Disclaimer for Cricket Score Counter.": "Descargo de responsabilidad para Cricket Score Counter.",
      "Cricket Score Counter is provided for informational and entertainment purposes only. We do not guarantee the accuracy or completeness of scores or match data.": "Cricket Score Counter se proporciona solo con fines informativos y de entretenimiento. No garantizamos la exactitud o integridad de los puntajes o datos de los partidos.",
      "Ads and Third-Party Content": "Anuncios y contenido de terceros",
      "This site may display ads served by Google AdSense. We are not responsible for the content of third-party ads or external links.": "Este sitio puede mostrar anuncios servidos por Google AdSense. No somos responsables del contenido de anuncios de terceros o enlaces externos.",
      "Limitation of Liability": "Limitación de responsabilidad",
      "We are not liable for any damages resulting from the use of this site.": "No somos responsables de ningún daño resultante del uso de este sitio.",
      // Privacy Policy page
      "Privacy Policy": "Política de privacidad",
      "Privacy Policy for Cricket Score Counter.": "Política de privacidad para Cricket Score Counter.",
      "This Privacy Policy explains how Cricket Score Counter collects, uses, and protects your information.": "Esta política de privacidad explica cómo Cricket Score Counter recopila, utiliza y protege su información.",
      "Information Collection": "Recopilación de información",
      "We may collect non-personal information such as browser type, device, and usage statistics. We do not collect personal information unless you provide it voluntarily.": "Podemos recopilar información no personal como el tipo de navegador, dispositivo y estadísticas de uso. No recopilamos información personal a menos que usted la proporcione voluntariamente.",
      "Cookies and Ads": "Cookies y anuncios",
      "We use cookies to improve your experience. We may serve ads by Google AdSense, which may use cookies to personalize ads.": "Usamos cookies para mejorar su experiencia. Podemos mostrar anuncios de Google AdSense, que pueden usar cookies para personalizar los anuncios.",
      "Third-Party Services": "Servicios de terceros",
      "We may use third-party services such as Google Analytics and AdSense. These services may collect and use information according to their own policies.": "Podemos usar servicios de terceros como Google Analytics y AdSense. Estos servicios pueden recopilar y usar información según sus propias políticas.",
      "Your Consent": "Su consentimiento",
      "By using our site, you consent to our privacy policy.": "Al usar nuestro sitio, usted acepta nuestra política de privacidad.",
      "Contact": "Contacto",
      "If you have questions, contact us at": "Si tiene preguntas, contáctenos en",
      Welcome: "Bienvenido",
      "Create Game": "Crear juego",
      "Join Game": "Unirse al juego",
      "Score Board": "Marcador",
      "Cricket Score Counter": "Contador de puntuación de cricket",
      "The easiest way to score, track, and share your cricket matches live.":
        "La forma más fácil de puntuar, seguir y compartir tus partidos de cricket en vivo.",
      "Start a new match or join an existing one to begin scoring instantly.":
        "Comienza un nuevo partido o únete a uno existente para empezar a puntuar al instante.",
      "Quick Match Setup": "Configuración rápida de partido",
      "Start a new game in seconds—no sign up needed!":
        "¡Comienza un nuevo juego en segundos—no necesitas registrarte!",
      "Real-Time Scoring": "Puntuación en tiempo real",
      "Update scores ball-by-ball and see instant results.":
        "Actualiza las puntuaciones bola a bola y ve resultados al instante.",
      "Easy Sharing": "Compartir fácilmente",
      "Share your match link with friends and family instantly.":
        "Comparte el enlace de tu partido con amigos y familiares al instante.",
      "Enter Game ID": "Introduce el ID del juego",
      "Game ID": "ID del juego",
      "Game ID is required": "El ID del juego es obligatorio",
      Cancel: "Cancelar",
      "View Score": "Ver puntuación",
      "Team 1 Name": "Nombre del equipo 1",
      "Team 2 Name": "Nombre del equipo 2",
      "Number of Overs": "Número de overs",
      "Please enter both team names.":
        "Por favor, introduce los nombres de ambos equipos.",
      "Please enter a valid number of overs (1-50).":
        "Por favor, introduce un número válido de overs (1-50).",
      "Enter Team Names": "Introduce los nombres de los equipos",
      "INDIA A": "INDIA A",
      "INDIA B": "INDIA B",
      "Team 1": "Equipo 1",
      "Team 2": "Equipo 2",
      "will flip the coin": "lanzará la moneda",
      "will select Heads or Tails": "elegirá cara o cruz",
      Heads: "Cara",
      Tails: "Cruz",
      "Select Heads or Tails first": "Selecciona primero cara o cruz",
      "Click to flip coin": "Haz clic para lanzar la moneda",
      "Tap the coin to flip": "Toca la moneda para lanzar",
      "Select Heads or Tails to enable coin":
        "Selecciona cara o cruz para habilitar la moneda",
      "Coin Flip Result:": "Resultado del lanzamiento:",
      "won the toss!": "ganó el sorteo!",
      "Bat First": "Batear primero",
      "Ball First": "Lanzar primero",
      "Start Match": "Comenzar partido",
      "Go with Toss": "Ir con el sorteo",
      "Copy Game ID": "Copiar ID del juego",
      "Share Game": "Compartir juego",
      "End Inning": "Terminar entrada",
      "End Game": "Terminar juego",
      "View History": "Ver historial",
      "Reset Game": "Reiniciar juego",
      "Game ID copied!": "¡ID del juego copiado!",
      "End Inning?": "¿Terminar entrada?",
      "End Game?": "¿Terminar juego?",
      "Are you sure you want to end the current inning? This action cannot be undone.":
        "¿Seguro que quieres terminar la entrada actual? Esta acción no se puede deshacer.",
      "Are you sure you want to end the game? This will reset all progress.":
        "¿Seguro que quieres terminar el juego? Esto reiniciará todo el progreso.",
      Yes: "Sí",
      "Congratulations!": "¡Felicidades!",
      "wins the match!": "gana el partido!",
      "It's a Tie! Super Over Time!": "¡Empate! ¡Super Over!",
      "Restart Match?": "¿Reiniciar partido?",
      "This will clear your current match.": "Esto borrará tu partido actual.",
      "Enter overs for the new match:":
        "Introduce los overs para el nuevo partido:",
      Overs: "Overs",
      Restart: "Reiniciar",
      "Set Number of Overs": "Establecer número de overs",
      "How many overs will this match have?":
        "¿Cuántos overs tendrá este partido?",
      "Set Overs": "Establecer overs",
      "Target Ready!": "¡Objetivo listo!",
      needs: "necesita",
      "runs to win": "carreras para ganar",
      "First innings complete. Start the chase when you’re ready.":
        "Primera entrada completa. Comienza la persecución cuando estés listo.",
      "Begin Chase": "Comenzar persecución",
    },
  },
  fr: {
    translation: {
      "has clinched victory! Celebrate the win and share the result.": "a remporté la victoire ! Célébrez la victoire et partagez le résultat.",
      "Both teams are tied. Get ready for a thrilling super over to decide the champion!": "Les deux équipes sont à égalité. Préparez-vous pour un super over palpitant pour décider du champion !",
      "Finish Game": "Terminer le match",
      "Start Super Over": "Commencer le Super Over",
      "Innings Breakdown": "Décomposition des manches",
      "No events for this team yet.": "Aucun événement pour cette équipe pour le moment.",
      // Home page
      "Home": "Accueil",
      "Cricket Score Counter – Free Online Live Score Tracker": "Cricket Score Counter – Suivi de score en direct gratuit en ligne",
      "Effortlessly count runs, track overs, and share live cricket scores with friends. Perfect for street, club, or school matches – keep your game organized and scores accessible from any device, anywhere.": "Comptez facilement les points, suivez les overs et partagez les scores de cricket en direct avec vos amis. Parfait pour les matchs de rue, de club ou d'école – gardez votre jeu organisé et les scores accessibles depuis n'importe quel appareil, n'importe où.",
      // Footer
      "Cricket Score Counter. All rights reserved.": "Cricket Score Counter. Tous droits réservés.",
      "This site uses cookies and may serve ads by Google AdSense. By using this site, you agree to our policies.": "Ce site utilise des cookies et peut diffuser des annonces via Google AdSense. En utilisant ce site, vous acceptez nos politiques.",
      // Disclaimer page
      "Disclaimer": "Avertissement",
      "Disclaimer for Cricket Score Counter.": "Avertissement pour Cricket Score Counter.",
      "Cricket Score Counter is provided for informational and entertainment purposes only. We do not guarantee the accuracy or completeness of scores or match data.": "Cricket Score Counter est fourni à des fins d'information et de divertissement uniquement. Nous ne garantissons pas l'exactitude ou l'exhaustivité des scores ou des données de match.",
      "Ads and Third-Party Content": "Publicités et contenu de tiers",
      "This site may display ads served by Google AdSense. We are not responsible for the content of third-party ads or external links.": "Ce site peut afficher des publicités diffusées par Google AdSense. Nous ne sommes pas responsables du contenu des publicités de tiers ou des liens externes.",
      "Limitation of Liability": "Limitation de responsabilité",
      "We are not liable for any damages resulting from the use of this site.": "Nous ne sommes pas responsables des dommages résultant de l'utilisation de ce site.",
      // Privacy Policy page
      "Privacy Policy": "Politique de confidentialité",
      "Privacy Policy for Cricket Score Counter.": "Politique de confidentialité pour Cricket Score Counter.",
      "This Privacy Policy explains how Cricket Score Counter collects, uses, and protects your information.": "Cette politique de confidentialité explique comment Cricket Score Counter collecte, utilise et protège vos informations.",
      "Information Collection": "Collecte d'informations",
      "We may collect non-personal information such as browser type, device, and usage statistics. We do not collect personal information unless you provide it voluntarily.": "Nous pouvons collecter des informations non personnelles telles que le type de navigateur, l'appareil et les statistiques d'utilisation. Nous ne collectons pas d'informations personnelles sauf si vous les fournissez volontairement.",
      "Cookies and Ads": "Cookies et publicités",
      "We use cookies to improve your experience. We may serve ads by Google AdSense, which may use cookies to personalize ads.": "Nous utilisons des cookies pour améliorer votre expérience. Nous pouvons diffuser des annonces via Google AdSense, qui peut utiliser des cookies pour personnaliser les annonces.",
      "Third-Party Services": "Services tiers",
      "We may use third-party services such as Google Analytics and AdSense. These services may collect and use information according to their own policies.": "Nous pouvons utiliser des services tiers tels que Google Analytics et AdSense. Ces services peuvent collecter et utiliser des informations conformément à leurs propres politiques.",
      "Your Consent": "Votre consentement",
      "By using our site, you consent to our privacy policy.": "En utilisant notre site, vous consentez à notre politique de confidentialité.",
      "Contact": "Contact",
      "If you have questions, contact us at": "Si vous avez des questions, contactez-nous à",
      Welcome: "Bienvenue",
      "Create Game": "Créer une partie",
      "Join Game": "Rejoindre une partie",
      "Score Board": "Tableau des scores",
      "Cricket Score Counter": "Compteur de score de cricket",
      "The easiest way to score, track, and share your cricket matches live.":
        "La façon la plus simple de compter, suivre et partager vos matchs de cricket en direct.",
      "Start a new match or join an existing one to begin scoring instantly.":
        "Commencez un nouveau match ou rejoignez-en un existant pour commencer à compter immédiatement.",
      "Quick Match Setup": "Configuration rapide du match",
      "Start a new game in seconds—no sign up needed!":
        "Commencez une nouvelle partie en quelques secondes—aucune inscription requise !",
      "Real-Time Scoring": "Score en temps réel",
      "Update scores ball-by-ball and see instant results.":
        "Mettez à jour les scores balle par balle et voyez les résultats instantanément.",
      "Easy Sharing": "Partage facile",
      "Share your match link with friends and family instantly.":
        "Partagez le lien de votre match avec vos amis et votre famille instantanément.",
      "Enter Game ID": "Entrez l'ID de la partie",
      "Game ID": "ID de la partie",
      "Game ID is required": "L'ID de la partie est requis",
      Cancel: "Annuler",
      "View Score": "Voir le score",
      "Team 1 Name": "Nom de l'équipe 1",
      "Team 2 Name": "Nom de l'équipe 2",
      "Number of Overs": "Nombre de manches",
      "Please enter both team names.":
        "Veuillez entrer les noms des deux équipes.",
      "Please enter a valid number of overs (1-50).":
        "Veuillez entrer un nombre valide de manches (1-50).",
      "Enter Team Names": "Entrez les noms des équipes",
      "INDIA A": "INDE A",
      "INDIA B": "INDE B",
      "Team 1": "Équipe 1",
      "Team 2": "Équipe 2",
      "will flip the coin": "va lancer la pièce",
      "will select Heads or Tails": "va choisir pile ou face",
      Heads: "Pile",
      Tails: "Face",
      "Select Heads or Tails first": "Sélectionnez d'abord pile ou face",
      "Click to flip coin": "Cliquez pour lancer la pièce",
      "Tap the coin to flip": "Appuyez sur la pièce pour la lancer",
      "Select Heads or Tails to enable coin":
        "Sélectionnez pile ou face pour activer la pièce",
      "Coin Flip Result:": "Résultat du lancer de pièce :",
      "won the toss!": "a gagné le tirage au sort !",
      "Bat First": "Battez en premier",
      "Ball First": "Lancez en premier",
      "Start Match": "Commencer le match",
      "Go with Toss": "Aller avec le tirage au sort",
      "Copy Game ID": "Copier l'ID de la partie",
      "Share Game": "Partager la partie",
      "End Inning": "Fin de la manche",
      "End Game": "Fin de la partie",
      "View History": "Voir l'historique",
      "Reset Game": "Réinitialiser la partie",
      "Game ID copied!": "ID de la partie copié !",
      "End Inning?": "Fin de la manche ?",
      "End Game?": "Fin de la partie ?",
      "Are you sure you want to end the current inning? This action cannot be undone.":
        "Êtes-vous sûr de vouloir terminer la manche en cours ? Cette action est irréversible.",
      "Are you sure you want to end the game? This will reset all progress.":
        "Êtes-vous sûr de vouloir terminer la partie ? Cela réinitialisera toute la progression.",
      Yes: "Oui",
      "Congratulations!": "Félicitations !",
      "wins the match!": "remporte le match !",
      "It's a Tie! Super Over Time!": "Égalité ! Super Over !",
      "Restart Match?": "Redémarrer le match ?",
      "This will clear your current match.":
        "Cela effacera votre match en cours.",
      "Enter overs for the new match:":
        "Entrez les overs pour le nouveau match :",
      Overs: "Overs",
      Restart: "Redémarrer",
      "Set Number of Overs": "Définir le nombre d'overs",
      "How many overs will this match have?":
        "Combien d'overs ce match aura-t-il ?",
      "Set Overs": "Définir les overs",
      "Target Ready!": "Cible prête !",
      needs: "a besoin de",
      "runs to win": "runs pour gagner",
      "First innings complete. Start the chase when you’re ready.":
        "Première manche terminée. Commencez la poursuite quand vous êtes prêt.",
      "Begin Chase": "Commencer la poursuite",
    },
  },
  de: {
    translation: {
      "has clinched victory! Celebrate the win and share the result.": "hat den Sieg errungen! Feiere den Sieg und teile das Ergebnis.",
      "Both teams are tied. Get ready for a thrilling super over to decide the champion!": "Beide Teams sind gleichauf. Mach dich bereit für ein spannendes Super Over, um den Champion zu bestimmen!",
      "Finish Game": "Spiel beenden",
      "Start Super Over": "Super Over starten",
      "Innings Breakdown": "Übersicht der Innings",
      "No events for this team yet.": "Für dieses Team gibt es noch keine Ereignisse.",
      // Home page
      "Home": "Startseite",
      "Cricket Score Counter – Free Online Live Score Tracker": "Cricket Score Counter – Kostenloser Online-Live-Score-Tracker",
      "Effortlessly count runs, track overs, and share live cricket scores with friends. Perfect for street, club, or school matches – keep your game organized and scores accessible from any device, anywhere.": "Zählen Sie mühelos Runs, verfolgen Sie Overs und teilen Sie Live-Cricket-Ergebnisse mit Freunden. Perfekt für Straßen-, Club- oder Schulspiele – halten Sie Ihr Spiel organisiert und die Ergebnisse von jedem Gerät aus zugänglich.",
      // Footer
      "Cricket Score Counter. All rights reserved.": "Cricket Score Counter. Alle Rechte vorbehalten.",
      "This site uses cookies and may serve ads by Google AdSense. By using this site, you agree to our policies.": "Diese Seite verwendet Cookies und kann Anzeigen von Google AdSense anzeigen. Durch die Nutzung dieser Seite stimmen Sie unseren Richtlinien zu.",
      // Disclaimer page
      "Disclaimer": "Haftungsausschluss",
      "Disclaimer for Cricket Score Counter.": "Haftungsausschluss für Cricket Score Counter.",
      "Cricket Score Counter is provided for informational and entertainment purposes only. We do not guarantee the accuracy or completeness of scores or match data.": "Cricket Score Counter wird nur zu Informations- und Unterhaltungszwecken bereitgestellt. Wir übernehmen keine Garantie für die Richtigkeit oder Vollständigkeit der Ergebnisse oder Spieldaten.",
      "Ads and Third-Party Content": "Werbung und Inhalte Dritter",
      "This site may display ads served by Google AdSense. We are not responsible for the content of third-party ads or external links.": "Diese Seite kann Anzeigen von Google AdSense anzeigen. Wir sind nicht verantwortlich für den Inhalt von Anzeigen Dritter oder externen Links.",
      "Limitation of Liability": "Haftungsbeschränkung",
      "We are not liable for any damages resulting from the use of this site.": "Wir haften nicht für Schäden, die sich aus der Nutzung dieser Seite ergeben.",
      // Privacy Policy page
      "Privacy Policy": "Datenschutzrichtlinie",
      "Privacy Policy for Cricket Score Counter.": "Datenschutzrichtlinie für Cricket Score Counter.",
      "This Privacy Policy explains how Cricket Score Counter collects, uses, and protects your information.": "Diese Datenschutzrichtlinie erklärt, wie Cricket Score Counter Ihre Informationen sammelt, verwendet und schützt.",
      "Information Collection": "Informationssammlung",
      "We may collect non-personal information such as browser type, device, and usage statistics. We do not collect personal information unless you provide it voluntarily.": "Wir können nicht-personenbezogene Informationen wie Browsertyp, Gerät und Nutzungsstatistiken sammeln. Wir sammeln keine personenbezogenen Daten, es sei denn, Sie stellen sie freiwillig zur Verfügung.",
      "Cookies and Ads": "Cookies und Werbung",
      "We use cookies to improve your experience. We may serve ads by Google AdSense, which may use cookies to personalize ads.": "Wir verwenden Cookies, um Ihre Erfahrung zu verbessern. Wir können Anzeigen von Google AdSense schalten, die Cookies zur Personalisierung von Anzeigen verwenden können.",
      "Third-Party Services": "Drittanbieterdienste",
      "We may use third-party services such as Google Analytics and AdSense. These services may collect and use information according to their own policies.": "Wir können Drittanbieterdienste wie Google Analytics und AdSense verwenden. Diese Dienste können Informationen gemäß ihren eigenen Richtlinien sammeln und verwenden.",
      "Your Consent": "Ihre Zustimmung",
      "By using our site, you consent to our privacy policy.": "Durch die Nutzung unserer Website stimmen Sie unserer Datenschutzrichtlinie zu.",
      "Contact": "Kontakt",
      "If you have questions, contact us at": "Wenn Sie Fragen haben, kontaktieren Sie uns unter",
      Welcome: "Willkommen",
      "Create Game": "Spiel erstellen",
      "Join Game": "Spiel beitreten",
      "Score Board": "Punktetafel",
      "Cricket Score Counter": "Cricket-Punktzähler",
      "The easiest way to score, track, and share your cricket matches live.":
        "Die einfachste Möglichkeit, Cricketspiele live zu punkten, zu verfolgen und zu teilen.",
      "Start a new match or join an existing one to begin scoring instantly.":
        "Starte ein neues Spiel oder trete einem bestehenden bei, um sofort mit dem Punkten zu beginnen.",
      "Quick Match Setup": "Schnelle Spiel-Einrichtung",
      "Start a new game in seconds—no sign up needed!":
        "Starte ein neues Spiel in Sekunden—keine Anmeldung erforderlich!",
      "Real-Time Scoring": "Echtzeit-Punktestand",
      "Update scores ball-by-ball and see instant results.":
        "Aktualisiere die Punkte Ball für Ball und sieh sofort die Ergebnisse.",
      "Easy Sharing": "Einfaches Teilen",
      "Share your match link with friends and family instantly.":
        "Teile den Spiel-Link sofort mit Freunden und Familie.",
      "Enter Game ID": "Spiel-ID eingeben",
      "Game ID": "Spiel-ID",
      "Game ID is required": "Spiel-ID ist erforderlich",
      Cancel: "Abbrechen",
      "View Score": "Punktestand anzeigen",
      "Team 1 Name": "Name Team 1",
      "Team 2 Name": "Name Team 2",
      "Number of Overs": "Anzahl der Overs",
      "Please enter both team names.": "Bitte gib beide Teamnamen ein.",
      "Please enter a valid number of overs (1-50).":
        "Bitte gib eine gültige Anzahl von Overs (1-50) ein.",
      "Enter Team Names": "Teamnamen eingeben",
      "INDIA A": "INDIEN A",
      "INDIA B": "INDIEN B",
      "Team 1": "Team 1",
      "Team 2": "Team 2",
      "will flip the coin": "wird die Münze werfen",
      "will select Heads or Tails": "wird Kopf oder Zahl wählen",
      Heads: "Kopf",
      Tails: "Zahl",
      "Select Heads or Tails first": "Wähle zuerst Kopf oder Zahl",
      "Click to flip coin": "Klicke, um die Münze zu werfen",
      "Tap the coin to flip": "Tippe auf die Münze, um sie zu werfen",
      "Select Heads or Tails to enable coin":
        "Wähle Kopf oder Zahl, um die Münze zu aktivieren",
      "Coin Flip Result:": "Ergebnis des Münzwurfs:",
      "won the toss!": "hat den Münzwurf gewonnen!",
      "Bat First": "Zuerst schlagen",
      "Ball First": "Zuerst werfen",
      "Start Match": "Spiel starten",
      "Go with Toss": "Mit Münzwurf beginnen",
      "Copy Game ID": "Spiel-ID kopieren",
      "Share Game": "Spiel teilen",
      "End Inning": "Spielabschnitt beenden",
      "End Game": "Spiel beenden",
      "View History": "Verlauf anzeigen",
      "Reset Game": "Spiel zurücksetzen",
      "Game ID copied!": "Spiel-ID kopiert!",
      "End Inning?": "Spielabschnitt beenden?",
      "End Game?": "Spiel beenden?",
      "Are you sure you want to end the current inning? This action cannot be undone.":
        "Bist du sicher, dass du den aktuellen Spielabschnitt beenden möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
      "Are you sure you want to end the game? This will reset all progress.":
        "Bist du sicher, dass du das Spiel beenden möchtest? Dadurch wird der gesamte Fortschritt zurückgesetzt.",
      Yes: "Ja",
      "Congratulations!": "Herzlichen Glückwunsch!",
      "wins the match!": "gewinnt das Spiel!",
      "It's a Tie! Super Over Time!": "Unentschieden! Super Over!",
      "Restart Match?": "Spiel neu starten?",
      "This will clear your current match.":
        "Dies wird dein aktuelles Spiel löschen.",
      "Enter overs for the new match:": "Overs für das neue Spiel eingeben:",
      Overs: "Overs",
      Restart: "Neustart",
      "Set Number of Overs": "Anzahl der Overs festlegen",
      "How many overs will this match have?":
        "Wie viele Overs wird dieses Spiel haben?",
      "Set Overs": "Overs festlegen",
      "Target Ready!": "Ziel bereit!",
      needs: "benötigt",
      "runs to win": "Runs zum Sieg",
      "First innings complete. Start the chase when you’re ready.":
        "Erste Innings abgeschlossen. Beginne die Aufholjagd, wenn du bereit bist.",
      "Begin Chase": "Aufholjagd beginnen",
    },
  },
  ru: {
    translation: {
      "has clinched victory! Celebrate the win and share the result.": "одержала победу! Отпразднуйте победу и поделитесь результатом.",
      "Both teams are tied. Get ready for a thrilling super over to decide the champion!": "Обе команды сравнялись. Приготовьтесь к захватывающему супер-оверу для определения чемпиона!",
      "Finish Game": "Завершить игру",
      "Start Super Over": "Начать супер-овер",
      "Innings Breakdown": "Разбор иннингов",
      "No events for this team yet.": "Для этой команды пока нет событий.",
      // Home page
      "Home": "Главная",
      "Cricket Score Counter – Free Online Live Score Tracker": "Cricket Score Counter – Бесплатный онлайн-трекер живого счета",
      "Effortlessly count runs, track overs, and share live cricket scores with friends. Perfect for street, club, or school matches – keep your game organized and scores accessible from any device, anywhere.": "Легко считайте раны, отслеживайте оверы и делитесь живыми результатами крикета с друзьями. Идеально подходит для уличных, клубных или школьных матчей – держите свою игру организованной, а результаты доступны с любого устройства, в любом месте.",
      // Footer
      "Cricket Score Counter. All rights reserved.": "Cricket Score Counter. Все права защищены.",
      "This site uses cookies and may serve ads by Google AdSense. By using this site, you agree to our policies.": "Этот сайт использует cookies и может показывать рекламу Google AdSense. Используя этот сайт, вы соглашаетесь с нашими правилами.",
      // Disclaimer page
      "Disclaimer": "Отказ от ответственности",
      "Disclaimer for Cricket Score Counter.": "Отказ от ответственности для Cricket Score Counter.",
      "Cricket Score Counter is provided for informational and entertainment purposes only. We do not guarantee the accuracy or completeness of scores or match data.": "Cricket Score Counter предоставляется только в информационных и развлекательных целях. Мы не гарантируем точность или полноту счетов или данных о матчах.",
      "Ads and Third-Party Content": "Реклама и сторонний контент",
      "This site may display ads served by Google AdSense. We are not responsible for the content of third-party ads or external links.": "Этот сайт может показывать рекламу Google AdSense. Мы не несем ответственности за содержание рекламы третьих лиц или внешних ссылок.",
      "Limitation of Liability": "Ограничение ответственности",
      "We are not liable for any damages resulting from the use of this site.": "Мы не несем ответственности за любые убытки, возникшие в результате использования этого сайта.",
      // Privacy Policy page
      "Privacy Policy": "Политика конфиденциальности",
      "Privacy Policy for Cricket Score Counter.": "Политика конфиденциальности для Cricket Score Counter.",
      "This Privacy Policy explains how Cricket Score Counter collects, uses, and protects your information.": "Эта политика конфиденциальности объясняет, как Cricket Score Counter собирает, использует и защищает вашу информацию.",
      "Information Collection": "Сбор информации",
      "We may collect non-personal information such as browser type, device, and usage statistics. We do not collect personal information unless you provide it voluntarily.": "Мы можем собирать неперсональную информацию, такую как тип браузера, устройство и статистика использования. Мы не собираем личную информацию, если вы не предоставляете ее добровольно.",
      "Cookies and Ads": "Cookies и реклама",
      "We use cookies to improve your experience. We may serve ads by Google AdSense, which may use cookies to personalize ads.": "Мы используем cookies для улучшения вашего опыта. Мы можем показывать рекламу Google AdSense, которая может использовать cookies для персонализации рекламы.",
      "Third-Party Services": "Сторонние сервисы",
      "We may use third-party services such as Google Analytics and AdSense. These services may collect and use information according to their own policies.": "Мы можем использовать сторонние сервисы, такие как Google Analytics и AdSense. Эти сервисы могут собирать и использовать информацию в соответствии со своей политикой.",
      "Your Consent": "Ваше согласие",
      "By using our site, you consent to our privacy policy.": "Используя наш сайт, вы соглашаетесь с нашей политикой конфиденциальности.",
      "Contact": "Контакт",
      "If you have questions, contact us at": "Если у вас есть вопросы, свяжитесь с нами по адресу",
      Welcome: "Добро пожаловать",
      "Create Game": "Создать игру",
      "Join Game": "Присоединиться к игре",
      "Score Board": "Табло",
      "Cricket Score Counter": "Счетчик очков крикета",
      "The easiest way to score, track, and share your cricket matches live.":
        "Самый простой способ вести счет, отслеживать и делиться вашими матчами по крикету в реальном времени.",
      "Start a new match or join an existing one to begin scoring instantly.":
        "Начните новый матч или присоединитесь к существующему, чтобы сразу начать вести счет.",
      "Quick Match Setup": "Быстрая настройка матча",
      "Start a new game in seconds—no sign up needed!":
        "Начните новую игру за секунды — регистрация не требуется!",
      "Real-Time Scoring": "Счет в реальном времени",
      "Update scores ball-by-ball and see instant results.":
        "Обновляйте счет после каждого броска и сразу видьте результаты.",
      "Easy Sharing": "Легкий обмен",
      "Share your match link with friends and family instantly.":
        "Мгновенно поделитесь ссылкой на матч с друзьями и семьей.",
      "Enter Game ID": "Введите ID игры",
      "Game ID": "ID игры",
      "Game ID is required": "Требуется ID игры",
      Cancel: "Отмена",
      "View Score": "Посмотреть счет",
      "Team 1 Name": "Название команды 1",
      "Team 2 Name": "Название команды 2",
      "Number of Overs": "Количество оверов",
      "Please enter both team names.":
        "Пожалуйста, введите названия обеих команд.",
      "Please enter a valid number of overs (1-50).":
        "Пожалуйста, введите допустимое количество оверов (1-50).",
      "Enter Team Names": "Введите названия команд",
      "INDIA A": "ИНДИЯ A",
      "INDIA B": "ИНДИЯ B",
      "Team 1": "Команда 1",
      "Team 2": "Команда 2",
      "will flip the coin": "будет бросать монету",
      "will select Heads or Tails": "выберет орел или решка",
      Heads: "Орел",
      Tails: "Решка",
      "Select Heads or Tails first": "Сначала выберите орел или решка",
      "Click to flip coin": "Нажмите, чтобы бросить монету",
      "Tap the coin to flip": "Коснитесь монеты, чтобы бросить",
      "Select Heads or Tails to enable coin":
        "Выберите орел или решка, чтобы активировать монету",
      "Coin Flip Result:": "Результат броска монеты:",
      "won the toss!": "выиграл жеребьевку!",
      "Bat First": "Бить первым",
      "Ball First": "Бросать первым",
      "Start Match": "Начать матч",
      "Go with Toss": "Начать с жеребьевки",
      "Copy Game ID": "Скопировать ID игры",
      "Share Game": "Поделиться игрой",
      "End Inning": "Закончить иннинг",
      "End Game": "Закончить игру",
      "View History": "Посмотреть историю",
      "Reset Game": "Сбросить игру",
      "Game ID copied!": "ID игры скопирован!",
      "End Inning?": "Закончить иннинг?",
      "End Game?": "Закончить игру?",
      "Are you sure you want to end the current inning? This action cannot be undone.":
        "Вы уверены, что хотите закончить текущий иннинг? Это действие нельзя отменить.",
      "Are you sure you want to end the game? This will reset all progress.":
        "Вы уверены, что хотите закончить игру? Это сбросит весь прогресс.",
      Yes: "Да",
      "Congratulations!": "Поздравляем!",
      "wins the match!": "выигрывает матч!",
      "It's a Tie! Super Over Time!": "Ничья! Супер овер!",
      "Restart Match?": "Перезапустить матч?",
      "This will clear your current match.": "Это очистит ваш текущий матч.",
      "Enter overs for the new match:": "Введите оверы для нового матча:",
      Overs: "Оверы",
      Restart: "Перезапустить",
      "Set Number of Overs": "Установить количество оверов",
      "How many overs will this match have?":
        "Сколько оверов будет в этом матче?",
      "Set Overs": "Установить оверы",
      "Target Ready!": "Цель готова!",
      needs: "нужно",
      "runs to win": "ранов для победы",
      "First innings complete. Start the chase when you’re ready.":
        "Первая половина завершена. Начинайте погоню, когда будете готовы.",
      "Begin Chase": "Начать погоню",
    },
  },
  pt: {
    translation: {
      "has clinched victory! Celebrate the win and share the result.": "conquistou a vitória! Comemore e compartilhe o resultado.",
      "Both teams are tied. Get ready for a thrilling super over to decide the champion!": "Ambas as equipes estão empatadas. Prepare-se para um emocionante super over para decidir o campeão!",
      "Finish Game": "Finalizar jogo",
      "Start Super Over": "Iniciar Super Over",
      "Innings Breakdown": "Resumo das entradas",
      "No events for this team yet.": "Ainda não há eventos para esta equipe.",
      // Home page
      "Home": "Início",
      "Cricket Score Counter – Free Online Live Score Tracker": "Cricket Score Counter – Rastreador de placar ao vivo gratuito online",
      "Effortlessly count runs, track overs, and share live cricket scores with friends. Perfect for street, club, or school matches – keep your game organized and scores accessible from any device, anywhere.": "Conte corridas facilmente, acompanhe os overs e compartilhe placares de críquete ao vivo com amigos. Perfeito para partidas de rua, clube ou escola – mantenha seu jogo organizado e os placares acessíveis de qualquer dispositivo, em qualquer lugar.",
      // Footer
      "Cricket Score Counter. All rights reserved.": "Cricket Score Counter. Todos os direitos reservados.",
      "This site uses cookies and may serve ads by Google AdSense. By using this site, you agree to our policies.": "Este site usa cookies e pode exibir anúncios do Google AdSense. Ao usar este site, você concorda com nossas políticas.",
      // Disclaimer page
      "Disclaimer": "Aviso legal",
      "Disclaimer for Cricket Score Counter.": "Aviso legal para Cricket Score Counter.",
      "Cricket Score Counter is provided for informational and entertainment purposes only. We do not guarantee the accuracy or completeness of scores or match data.": "Cricket Score Counter é fornecido apenas para fins informativos e de entretenimento. Não garantimos a precisão ou integridade das pontuações ou dados das partidas.",
      "Ads and Third-Party Content": "Anúncios e conteúdo de terceiros",
      "This site may display ads served by Google AdSense. We are not responsible for the content of third-party ads or external links.": "Este site pode exibir anúncios do Google AdSense. Não somos responsáveis pelo conteúdo de anúncios de terceiros ou links externos.",
      "Limitation of Liability": "Limitação de responsabilidade",
      "We are not liable for any damages resulting from the use of this site.": "Não somos responsáveis por quaisquer danos resultantes do uso deste site.",
      // Privacy Policy page
      "Privacy Policy": "Política de Privacidade",
      "Privacy Policy for Cricket Score Counter.": "Política de Privacidade para Cricket Score Counter.",
      "This Privacy Policy explains how Cricket Score Counter collects, uses, and protects your information.": "Esta Política de Privacidade explica como o Cricket Score Counter coleta, usa e protege suas informações.",
      "Information Collection": "Coleta de Informações",
      "We may collect non-personal information such as browser type, device, and usage statistics. We do not collect personal information unless you provide it voluntarily.": "Podemos coletar informações não pessoais, como tipo de navegador, dispositivo e estatísticas de uso. Não coletamos informações pessoais, a menos que você as forneça voluntariamente.",
      "Cookies and Ads": "Cookies e Anúncios",
      "We use cookies to improve your experience. We may serve ads by Google AdSense, which may use cookies to personalize ads.": "Usamos cookies para melhorar sua experiência. Podemos exibir anúncios do Google AdSense, que podem usar cookies para personalizar anúncios.",
      "Third-Party Services": "Serviços de Terceiros",
      "We may use third-party services such as Google Analytics and AdSense. These services may collect and use information according to their own policies.": "Podemos usar serviços de terceiros, como Google Analytics e AdSense. Esses serviços podem coletar e usar informações de acordo com suas próprias políticas.",
      "Your Consent": "Seu Consentimento",
      "By using our site, you consent to our privacy policy.": "Ao usar nosso site, você concorda com nossa política de privacidade.",
      "Contact": "Contato",
      "If you have questions, contact us at": "Se você tiver dúvidas, entre em contato conosco em",
      Welcome: "Bem-vindo",
      "Create Game": "Criar jogo",
      "Join Game": "Entrar no jogo",
      "Score Board": "Placar",
      "Cricket Score Counter": "Contador de Pontos de Críquete",
      "The easiest way to score, track, and share your cricket matches live.":
        "A maneira mais fácil de marcar, acompanhar e compartilhar suas partidas de críquete ao vivo.",
      "Start a new match or join an existing one to begin scoring instantly.":
        "Comece uma nova partida ou entre em uma existente para começar a marcar instantaneamente.",
      "Quick Match Setup": "Configuração rápida de partida",
      "Start a new game in seconds—no sign up needed!":
        "Comece um novo jogo em segundos—não é necessário cadastro!",
      "Real-Time Scoring": "Pontuação em tempo real",
      "Update scores ball-by-ball and see instant results.":
        "Atualize os pontos bola a bola e veja resultados instantâneos.",
      "Easy Sharing": "Compartilhamento fácil",
      "Share your match link with friends and family instantly.":
        "Compartilhe o link da sua partida com amigos e família instantaneamente.",
      "Enter Game ID": "Digite o ID do jogo",
      "Game ID": "ID do jogo",
      "Game ID is required": "O ID do jogo é obrigatório",
      Cancel: "Cancelar",
      "View Score": "Ver pontuação",
      "Team 1 Name": "Nome do time 1",
      "Team 2 Name": "Nome do time 2",
      "Number of Overs": "Número de overs",
      "Please enter both team names.":
        "Por favor, insira os nomes dos dois times.",
      "Please enter a valid number of overs (1-50).":
        "Por favor, insira um número válido de overs (1-50).",
      "Enter Team Names": "Digite os nomes dos times",
      "INDIA A": "ÍNDIA A",
      "INDIA B": "ÍNDIA B",
      "Team 1": "Time 1",
      "Team 2": "Time 2",
      "will flip the coin": "vai jogar a moeda",
      "will select Heads or Tails": "vai escolher cara ou coroa",
      Heads: "Cara",
      Tails: "Coroa",
      "Select Heads or Tails first": "Selecione primeiro cara ou coroa",
      "Click to flip coin": "Clique para jogar a moeda",
      "Tap the coin to flip": "Toque na moeda para jogar",
      "Select Heads or Tails to enable coin":
        "Selecione cara ou coroa para ativar a moeda",
      "Coin Flip Result:": "Resultado do lançamento da moeda:",
      "won the toss!": "ganhou o sorteio!",
      "Bat First": "Bater primeiro",
      "Ball First": "Lançar primeiro",
      "Start Match": "Iniciar partida",
      "Go with Toss": "Ir com o sorteio",
      "Copy Game ID": "Copiar ID do jogo",
      "Share Game": "Compartilhar jogo",
      "End Inning": "Terminar entrada",
      "End Game": "Terminar jogo",
      "View History": "Ver histórico",
      "Reset Game": "Redefinir jogo",
      "Game ID copied!": "ID do jogo copiado!",
      "End Inning?": "Terminar entrada?",
      "End Game?": "Terminar jogo?",
      "Are you sure you want to end the current inning? This action cannot be undone.":
        "Tem certeza de que deseja terminar a entrada atual? Esta ação não pode ser desfeita.",
      "Are you sure you want to end the game? This will reset all progress.":
        "Tem certeza de que deseja terminar o jogo? Isso irá redefinir todo o progresso.",
      Yes: "Sim",
      "Congratulations!": "Parabéns!",
      "wins the match!": "vence a partida!",
      "It's a Tie! Super Over Time!": "Empate! Super Over!",
      "Restart Match?": "Reiniciar partida?",
      "This will clear your current match.": "Isso limpará sua partida atual.",
      "Enter overs for the new match:": "Insira os overs para a nova partida:",
      Overs: "Overs",
      Restart: "Reiniciar",
      "Set Number of Overs": "Definir número de overs",
      "How many overs will this match have?":
        "Quantos overs terá esta partida?",
      "Set Overs": "Definir overs",
      "Target Ready!": "Alvo pronto!",
      needs: "precisa",
      "runs to win": "corridas para vencer",
      "First innings complete. Start the chase when you’re ready.":
        "Primeira entrada completa. Comece a perseguição quando estiver pronto.",
      "Begin Chase": "Começar perseguição",
    },
  },
  ja: {
    translation: {
      "has clinched victory! Celebrate the win and share the result.": "勝利を収めました！勝利を祝って結果を共有しましょう。",
      "Both teams are tied. Get ready for a thrilling super over to decide the champion!": "両チームが同点です。チャンピオンを決めるスリリングなスーパーオーバーの準備をしましょう！",
      "Finish Game": "試合終了",
      "Start Super Over": "スーパーオーバー開始",
      "Innings Breakdown": "イニングの内訳",
      "No events for this team yet.": "このチームのイベントはまだありません。",
      // Home page
      "Home": "ホーム",
      "Cricket Score Counter – Free Online Live Score Tracker": "Cricket Score Counter – 無料オンラインライブスコアトラッカー",
      "Effortlessly count runs, track overs, and share live cricket scores with friends. Perfect for street, club, or school matches – keep your game organized and scores accessible from any device, anywhere.": "簡単にランをカウントし、オーバーを追跡し、友達とライブクリケットスコアを共有できます。ストリート、クラブ、学校の試合に最適 – ゲームを整理し、どのデバイスからでもどこからでもスコアにアクセスできます。",
      // Footer
      "Cricket Score Counter. All rights reserved.": "Cricket Score Counter。全著作権所有。",
      "This site uses cookies and may serve ads by Google AdSense. By using this site, you agree to our policies.": "このサイトはクッキーを使用し、Google AdSenseによる広告を表示する場合があります。このサイトを利用することで、当社のポリシーに同意したことになります。",
      // Disclaimer page
      "Disclaimer": "免責事項",
      "Disclaimer for Cricket Score Counter.": "Cricket Score Counterの免責事項。",
      "Cricket Score Counter is provided for informational and entertainment purposes only. We do not guarantee the accuracy or completeness of scores or match data.": "Cricket Score Counterは情報提供および娯楽目的で提供されています。スコアや試合データの正確性や完全性は保証しません。",
      "Ads and Third-Party Content": "広告およびサードパーティコンテンツ",
      "This site may display ads served by Google AdSense. We are not responsible for the content of third-party ads or external links.": "このサイトではGoogle AdSenseによる広告が表示される場合があります。第三者の広告や外部リンクの内容については責任を負いません。",
      "Limitation of Liability": "責任の制限",
      "We are not liable for any damages resulting from the use of this site.": "本サイトの利用により生じたいかなる損害についても責任を負いません。",
      // Privacy Policy page
      "Privacy Policy": "プライバシーポリシー",
      "Privacy Policy for Cricket Score Counter.": "Cricket Score Counterのプライバシーポリシー。",
      "This Privacy Policy explains how Cricket Score Counter collects, uses, and protects your information.": "このプライバシーポリシーは、Cricket Score Counterがあなたの情報をどのように収集、使用、保護するかを説明します。",
      "Information Collection": "情報の収集",
      "We may collect non-personal information such as browser type, device, and usage statistics. We do not collect personal information unless you provide it voluntarily.": "ブラウザの種類、デバイス、利用統計などの非個人情報を収集する場合があります。個人情報は、あなたが自発的に提供しない限り収集しません。",
      "Cookies and Ads": "クッキーと広告",
      "We use cookies to improve your experience. We may serve ads by Google AdSense, which may use cookies to personalize ads.": "クッキーを使用して体験を向上させます。Google AdSenseによる広告を表示する場合があり、広告のパーソナライズにクッキーが使用されることがあります。",
      "Third-Party Services": "サードパーティサービス",
      "We may use third-party services such as Google Analytics and AdSense. These services may collect and use information according to their own policies.": "Google AnalyticsやAdSenseなどのサードパーティサービスを利用する場合があります。これらのサービスは独自のポリシーに従って情報を収集・利用する場合があります。",
      "Your Consent": "あなたの同意",
      "By using our site, you consent to our privacy policy.": "当サイトを利用することで、プライバシーポリシーに同意したことになります。",
      "Contact": "お問い合わせ",
      "If you have questions, contact us at": "ご質問がある場合は、次のアドレスまでご連絡ください：",
      Welcome: "Bem-vindo",
      "Create Game": "Criar jogo",
      "Join Game": "Entrar no jogo",
      "Score Board": "Placar",
      "Cricket Score Counter": "Contador de Pontos de Críquete",
      "The easiest way to score, track, and share your cricket matches live.":
        "A maneira mais fácil de marcar, acompanhar e compartilhar suas partidas de críquete ao vivo.",
      "Start a new match or join an existing one to begin scoring instantly.":
        "Comece uma nova partida ou entre em uma existente para começar a marcar instantaneamente.",
      "Quick Match Setup": "Configuração rápida de partida",
      "Start a new game in seconds—no sign up needed!":
        "Comece um novo jogo em segundos—não é necessário cadastro!",
      "Real-Time Scoring": "Pontuação em tempo real",
      "Update scores ball-by-ball and see instant results.":
        "Atualize os pontos bola a bola e veja resultados instantâneos.",
      "Easy Sharing": "Compartilhamento fácil",
      "Share your match link with friends and family instantly.":
        "Compartilhe o link da sua partida com amigos e família instantaneamente.",
      "Enter Game ID": "Digite o ID do jogo",
      "Game ID": "ID do jogo",
      "Game ID is required": "O ID do jogo é obrigatório",
      Cancel: "Cancelar",
      "View Score": "Ver pontuação",
      "Team 1 Name": "Nome do time 1",
      "Team 2 Name": "Nome do time 2",
      "Number of Overs": "Número de overs",
      "Please enter both team names.":
        "Por favor, insira os nomes dos dois times.",
      "Please enter a valid number of overs (1-50).":
        "Por favor, insira um número válido de overs (1-50).",
      "Enter Team Names": "Digite os nomes dos times",
      "INDIA A": "ÍNDIA A",
      "INDIA B": "ÍNDIA B",
      "Team 1": "Time 1",
      "Team 2": "Time 2",
      "will flip the coin": "vai jogar a moeda",
      "will select Heads or Tails": "vai escolher cara ou coroa",
      Heads: "Cara",
      Tails: "Coroa",
      "Select Heads or Tails first": "Selecione primeiro cara ou coroa",
      "Click to flip coin": "Clique para jogar a moeda",
      "Tap the coin to flip": "Toque na moeda para jogar",
      "Select Heads or Tails to enable coin":
        "Selecione cara ou coroa para ativar a moeda",
      "Coin Flip Result:": "Resultado do lançamento da moeda:",
      "won the toss!": "ganhou o sorteio!",
      "Bat First": "Bater primeiro",
      "Ball First": "Lançar primeiro",
      "Start Match": "Iniciar partida",
      "Go with Toss": "Ir com o sorteio",
      "Copy Game ID": "Copiar ID do jogo",
      "Share Game": "Compartilhar jogo",
      "End Inning": "Terminar entrada",
      "End Game": "Terminar jogo",
      "View History": "Ver histórico",
      "Reset Game": "Redefinir jogo",
      "Game ID copied!": "ID do jogo copiado!",
      "End Inning?": "Terminar entrada?",
      "End Game?": "Terminar jogo?",
      "Are you sure you want to end the current inning? This action cannot be undone.":
        "Tem certeza de que deseja terminar a entrada atual? Esta ação não pode ser desfeita.",
      "Are you sure you want to end the game? This will reset all progress.":
        "Tem certeza de que deseja terminar o jogo? Isso irá redefinir todo o progresso.",
      Yes: "はい",
      "Congratulations!": "おめでとうございます！",
      "wins the match!": "試合に勝ちました！",
      "It's a Tie! Super Over Time!": "引き分け！スーパーオーバー！",
      "Restart Match?": "試合を再開しますか？",
      "This will clear your current match.": "現在の試合がクリアされます。",
      "Enter overs for the new match:":
        "新しい試合のオーバー数を入力してください：",
      Overs: "オーバー",
      Restart: "再開",
      "Set Number of Overs": "オーバー数を設定",
      "How many overs will this match have?": "この試合は何オーバーですか？",
      "Set Overs": "オーバーを設定",
      "Target Ready!": "ターゲット準備完了！",
      needs: "必要",
      "runs to win": "勝つためのラン",
      "First innings complete. Start the chase when you’re ready.":
        "最初のイニングが完了しました。準備ができたらチェイスを開始してください。",
      "Begin Chase": "チェイス開始",
    },
  },
  it: {
    translation: {
      "has clinched victory! Celebrate the win and share the result.": "ha conquistato la vittoria! Festeggia la vittoria e condividi il risultato.",
      "Both teams are tied. Get ready for a thrilling super over to decide the champion!": "Entrambe le squadre sono in parità. Preparati a un emozionante super over per decidere il campione!",
      "Finish Game": "Termina partita",
      "Start Super Over": "Inizia Super Over",
      "Innings Breakdown": "Dettaglio degli innings",
      "No events for this team yet.": "Nessun evento per questa squadra al momento.",
      // Home page
      "Home": "Home",
      "Cricket Score Counter – Free Online Live Score Tracker": "Cricket Score Counter – Tracker di punteggio live online gratuito",
      "Effortlessly count runs, track overs, and share live cricket scores with friends. Perfect for street, club, or school matches – keep your game organized and scores accessible from any device, anywhere.": "Conta facilmente i punti, traccia gli over e condividi i punteggi live di cricket con gli amici. Perfetto per partite di strada, club o scuola – tieni il tuo gioco organizzato e i punteggi accessibili da qualsiasi dispositivo, ovunque.",
      // Footer
      "Cricket Score Counter. All rights reserved.": "Cricket Score Counter. Tutti i diritti riservati.",
      "This site uses cookies and may serve ads by Google AdSense. By using this site, you agree to our policies.": "Questo sito utilizza i cookie e può mostrare annunci di Google AdSense. Utilizzando questo sito, accetti le nostre politiche.",
      // Disclaimer page
      "Disclaimer": "Disclaimer",
      "Disclaimer for Cricket Score Counter.": "Disclaimer per Cricket Score Counter.",
      "Cricket Score Counter is provided for informational and entertainment purposes only. We do not guarantee the accuracy or completeness of scores or match data.": "Cricket Score Counter è fornito solo a scopo informativo e di intrattenimento. Non garantiamo l'accuratezza o la completezza dei punteggi o dei dati delle partite.",
      "Ads and Third-Party Content": "Annunci e contenuti di terze parti",
      "This site may display ads served by Google AdSense. We are not responsible for the content of third-party ads or external links.": "Questo sito può mostrare annunci forniti da Google AdSense. Non siamo responsabili per il contenuto di annunci di terze parti o link esterni.",
      "Limitation of Liability": "Limitazione di responsabilità",
      "We are not liable for any damages resulting from the use of this site.": "Non siamo responsabili per eventuali danni derivanti dall'uso di questo sito.",
      // Privacy Policy page
      "Privacy Policy": "Informativa sulla privacy",
      "Privacy Policy for Cricket Score Counter.": "Informativa sulla privacy per Cricket Score Counter.",
      "This Privacy Policy explains how Cricket Score Counter collects, uses, and protects your information.": "Questa informativa sulla privacy spiega come Cricket Score Counter raccoglie, utilizza e protegge le tue informazioni.",
      "Information Collection": "Raccolta delle informazioni",
      "We may collect non-personal information such as browser type, device, and usage statistics. We do not collect personal information unless you provide it voluntarily.": "Potremmo raccogliere informazioni non personali come il tipo di browser, il dispositivo e le statistiche di utilizzo. Non raccogliamo informazioni personali a meno che tu non le fornisca volontariamente.",
      "Cookies and Ads": "Cookie e annunci",
      "We use cookies to improve your experience. We may serve ads by Google AdSense, which may use cookies to personalize ads.": "Utilizziamo i cookie per migliorare la tua esperienza. Potremmo mostrare annunci tramite Google AdSense, che può utilizzare i cookie per personalizzare gli annunci.",
      "Third-Party Services": "Servizi di terze parti",
      "We may use third-party services such as Google Analytics and AdSense. These services may collect and use information according to their own policies.": "Potremmo utilizzare servizi di terze parti come Google Analytics e AdSense. Questi servizi possono raccogliere e utilizzare informazioni secondo le proprie politiche.",
      "Your Consent": "Il tuo consenso",
      "By using our site, you consent to our privacy policy.": "Utilizzando il nostro sito, acconsenti alla nostra informativa sulla privacy.",
      "Contact": "Contatto",
      "If you have questions, contact us at": "Se hai domande, contattaci a",
      Welcome: "Bem-vindo",
      "Create Game": "Criar jogo",
      "Join Game": "Entrar no jogo",
      "Score Board": "Placar",
      "Cricket Score Counter": "Contador de Pontos de Críquete",
      "The easiest way to score, track, and share your cricket matches live.":
        "A maneira mais fácil de marcar, acompanhar e compartilhar suas partidas de críquete ao vivo.",
      "Start a new match or join an existing one to begin scoring instantly.":
        "Comece uma nova partida ou entre em uma existente para começar a marcar instantaneamente.",
      "Quick Match Setup": "Configuração rápida de partida",
      "Start a new game in seconds—no sign up needed!":
        "Comece um novo jogo em segundos—não é necessário cadastro!",
      "Real-Time Scoring": "Pontuação em tempo real",
      "Update scores ball-by-ball and see instant results.":
        "Atualize os pontos bola a bola e veja resultados instantâneos.",
      "Easy Sharing": "Compartilhamento fácil",
      "Share your match link with friends and family instantly.":
        "Compartilhe o link da sua partida com amigos e família instantaneamente.",
      "Enter Game ID": "Digite o ID do jogo",
      "Game ID": "ID do jogo",
      "Game ID is required": "O ID do jogo é obrigatório",
      Cancel: "Cancelar",
      "View Score": "Ver pontuação",
      "Team 1 Name": "Nome do time 1",
      "Team 2 Name": "Nome do time 2",
      "Number of Overs": "Número de overs",
      "Please enter both team names.":
        "Por favor, insira os nomes dos dois times.",
      "Please enter a valid number of overs (1-50).":
        "Por favor, insira um número válido de overs (1-50).",
      "Enter Team Names": "Digite os nomes dos times",
      "INDIA A": "ÍNDIA A",
      "INDIA B": "ÍNDIA B",
      "Team 1": "Time 1",
      "Team 2": "Time 2",
      "will flip the coin": "vai jogar a moeda",
      "will select Heads or Tails": "vai escolher cara ou coroa",
      Heads: "Cara",
      Tails: "Coroa",
      "Select Heads or Tails first": "Selecione primeiro cara ou coroa",
      "Click to flip coin": "Clique para jogar a moeda",
      "Tap the coin to flip": "Toque na moeda para jogar",
      "Select Heads or Tails to enable coin":
        "Selecione cara ou coroa para ativar a moeda",
      "Coin Flip Result:": "Resultado do lançamento da moeda:",
      "won the toss!": "ganhou o sorteio!",
      "Bat First": "Bater primeiro",
      "Ball First": "Lançar primeiro",
      "Start Match": "Iniciar partida",
      "Go with Toss": "Ir com o sorteio",
      "Copy Game ID": "Copiar ID do jogo",
      "Share Game": "Compartilhar jogo",
      "End Inning": "Terminar entrada",
      "End Game": "Terminar jogo",
      "View History": "Ver histórico",
      "Reset Game": "Redefinir jogo",
      "Game ID copied!": "ID do jogo copiado!",
      "End Inning?": "Terminar entrada?",
      "End Game?": "Terminar jogo?",
      "Are you sure you want to end the current inning? This action cannot be undone.":
        "Tem certeza de que deseja terminar a entrada atual? Esta ação não pode ser desfeita.",
      "Are you sure you want to end the game? This will reset all progress.":
        "Tem certeza de que deseja terminar o jogo? Isso irá redefinir todo o progresso.",
      Yes: "Sì",
      "Congratulations!": "Congratulazioni!",
      "wins the match!": "vince la partita!",
      "It's a Tie! Super Over Time!": "Pareggio! Super Over!",
      "Restart Match?": "Riavviare la partita?",
      "This will clear your current match.":
        "Questo cancellerà la tua partita attuale.",
      "Enter overs for the new match:":
        "Inserisci gli over per la nuova partita:",
      Overs: "Over",
      Restart: "Riavvia",
      "Set Number of Overs": "Imposta il numero di over",
      "How many overs will this match have?":
        "Quanti over avrà questa partita?",
      "Set Overs": "Imposta over",
      "Target Ready!": "Obiettivo pronto!",
      needs: "necessita",
      "runs to win": "run per vincere",
      "First innings complete. Start the chase when you’re ready.":
        "Prima manche completata. Inizia l'inseguimento quando sei pronto.",
      "Begin Chase": "Inizia l'inseguimento",
    },
  },
  tr: {
    translation: {
      "has clinched victory! Celebrate the win and share the result.": "zaferi kazandı! Zaferi kutlayın ve sonucu paylaşın.",
      "Both teams are tied. Get ready for a thrilling super over to decide the champion!": "Her iki takım da berabere. Şampiyonu belirlemek için heyecan verici bir süper over'a hazırlanın!",
      "Finish Game": "Oyunu Bitir",
      "Start Super Over": "Süper Over'a Başla",
      "Innings Breakdown": "Vuruşların dökümü",
      "No events for this team yet.": "Bu takım için henüz etkinlik yok.",
      // Home page
      "Home": "Ana Sayfa",
      "Cricket Score Counter – Free Online Live Score Tracker": "Cricket Score Counter – Ücretsiz Çevrimiçi Canlı Skor Takipçisi",
      "Effortlessly count runs, track overs, and share live cricket scores with friends. Perfect for street, club, or school matches – keep your game organized and scores accessible from any device, anywhere.": "Kolayca sayı sayın, over'ları takip edin ve canlı kriket skorlarını arkadaşlarınızla paylaşın. Sokak, kulüp veya okul maçları için mükemmel – oyununuzu düzenli tutun ve skorlar herhangi bir cihazdan, her yerden erişilebilir olsun.",
      // Footer
      "Cricket Score Counter. All rights reserved.": "Cricket Score Counter. Tüm hakları saklıdır.",
      "This site uses cookies and may serve ads by Google AdSense. By using this site, you agree to our policies.": "Bu site çerez kullanır ve Google AdSense tarafından reklamlar sunabilir. Bu siteyi kullanarak politikalarımızı kabul etmiş olursunuz.",
      // Disclaimer page
      "Disclaimer": "Feragatname",
      "Disclaimer for Cricket Score Counter.": "Cricket Score Counter için Feragatname.",
      "Cricket Score Counter is provided for informational and entertainment purposes only. We do not guarantee the accuracy or completeness of scores or match data.": "Cricket Score Counter yalnızca bilgilendirme ve eğlence amaçlı sunulmaktadır. Skorların veya maç verilerinin doğruluğunu veya eksiksizliğini garanti etmiyoruz.",
      "Ads and Third-Party Content": "Reklamlar ve Üçüncü Taraf İçerik",
      "This site may display ads served by Google AdSense. We are not responsible for the content of third-party ads or external links.": "Bu site Google AdSense tarafından sunulan reklamları gösterebilir. Üçüncü taraf reklamların veya harici bağlantıların içeriğinden sorumlu değiliz.",
      "Limitation of Liability": "Sorumluluğun Sınırlandırılması",
      "We are not liable for any damages resulting from the use of this site.": "Bu sitenin kullanımından kaynaklanan herhangi bir zarardan sorumlu değiliz.",
      // Privacy Policy page
      "Privacy Policy": "Gizlilik Politikası",
      "Privacy Policy for Cricket Score Counter.": "Cricket Score Counter için Gizlilik Politikası.",
      "This Privacy Policy explains how Cricket Score Counter collects, uses, and protects your information.": "Bu Gizlilik Politikası, Cricket Score Counter'ın bilgilerinizi nasıl topladığını, kullandığını ve koruduğunu açıklar.",
      "Information Collection": "Bilgi Toplama",
      "We may collect non-personal information such as browser type, device, and usage statistics. We do not collect personal information unless you provide it voluntarily.": "Tarayıcı türü, cihaz ve kullanım istatistikleri gibi kişisel olmayan bilgileri toplayabiliriz. Kişisel bilgileri siz gönüllü olarak vermedikçe toplamıyoruz.",
      "Cookies and Ads": "Çerezler ve Reklamlar",
      "We use cookies to improve your experience. We may serve ads by Google AdSense, which may use cookies to personalize ads.": "Deneyiminizi geliştirmek için çerezler kullanıyoruz. Google AdSense tarafından reklamlar sunabiliriz, bu reklamlar çerezleri kişiselleştirmek için kullanabilir.",
      "Third-Party Services": "Üçüncü Taraf Hizmetler",
      "We may use third-party services such as Google Analytics and AdSense. These services may collect and use information according to their own policies.": "Google Analytics ve AdSense gibi üçüncü taraf hizmetler kullanabiliriz. Bu hizmetler kendi politikalarına göre bilgi toplayabilir ve kullanabilir.",
      "Your Consent": "Onayınız",
      "By using our site, you consent to our privacy policy.": "Sitemizi kullanarak gizlilik politikamıza onay vermiş olursunuz.",
      "Contact": "İletişim",
      "If you have questions, contact us at": "Sorularınız varsa, bize şu adresten ulaşın:",
      Welcome: "Bem-vindo",
      "Create Game": "Criar jogo",
      "Join Game": "Entrar no jogo",
      "Score Board": "Placar",
      "Cricket Score Counter": "Contador de Pontos de Críquete",
      "The easiest way to score, track, and share your cricket matches live.":
        "A maneira mais fácil de marcar, acompanhar e compartilhar suas partidas de críquete ao vivo.",
      "Start a new match or join an existing one to begin scoring instantly.":
        "Comece uma nova partida ou entre em uma existente para começar a marcar instantaneamente.",
      "Quick Match Setup": "Configuração rápida de partida",
      "Start a new game in seconds—no sign up needed!":
        "Comece um novo jogo em segundos—não é necessário cadastro!",
      "Real-Time Scoring": "Pontuação em tempo real",
      "Update scores ball-by-ball and see instant results.":
        "Atualize os pontos bola a bola e veja resultados instantâneos.",
      "Easy Sharing": "Compartilhamento fácil",
      "Share your match link with friends and family instantly.":
        "Compartilhe o link da sua partida com amigos e família instantaneamente.",
      "Enter Game ID": "Digite o ID do jogo",
      "Game ID": "ID do jogo",
      "Game ID is required": "O ID do jogo é obrigatório",
      Cancel: "Cancelar",
      "View Score": "Ver pontuação",
      "Team 1 Name": "Nome do time 1",
      "Team 2 Name": "Nome do time 2",
      "Number of Overs": "Número de overs",
      "Please enter both team names.":
        "Por favor, insira os nomes dos dois times.",
      "Please enter a valid number of overs (1-50).":
        "Por favor, insira um número válido de overs (1-50).",
      "Enter Team Names": "Digite os nomes dos times",
      "INDIA A": "ÍNDIA A",
      "INDIA B": "ÍNDIA B",
      "Team 1": "Time 1",
      "Team 2": "Time 2",
      "will flip the coin": "vai jogar a moeda",
      "will select Heads or Tails": "vai escolher cara ou coroa",
      Heads: "Cara",
      Tails: "Coroa",
      "Select Heads or Tails first": "Selecione primeiro cara ou coroa",
      "Click to flip coin": "Clique para jogar a moeda",
      "Tap the coin to flip": "Toque na moeda para jogar",
      "Select Heads or Tails to enable coin":
        "Selecione cara ou coroa para ativar a moeda",
      "Coin Flip Result:": "Resultado do lançamento da moeda:",
      "won the toss!": "ganhou o sorteio!",
      "Bat First": "Bater primeiro",
      "Ball First": "Lançar primeiro",
      "Start Match": "Iniciar partida",
      "Go with Toss": "Ir com o sorteio",
      "Copy Game ID": "Copiar ID do jogo",
      "Share Game": "Compartilhar jogo",
      "End Inning": "Terminar entrada",
      "End Game": "Terminar jogo",
      "View History": "Ver histórico",
      "Reset Game": "Redefinir jogo",
      "Game ID copied!": "ID do jogo copiado!",
      "End Inning?": "Terminar entrada?",
      "End Game?": "Terminar jogo?",
      "Are you sure you want to end the current inning? This action cannot be undone.":
        "Tem certeza de que deseja terminar a entrada atual? Esta ação não pode ser desfeita.",
      "Are you sure you want to end the game? This will reset all progress.":
        "Tem certeza de que deseja terminar o jogo? Isso irá redefinir todo o progresso.",
      Yes: "Evet",
      "Congratulations!": "Tebrikler!",
      "wins the match!": "maçı kazandı!",
      "It's a Tie! Super Over Time!": "Beraberlik! Süper Over!",
      "Restart Match?": "Maçı yeniden başlat?",
      "This will clear your current match.":
        "Bu, mevcut maçınızı temizleyecek.",
      "Enter overs for the new match:": "Yeni maç için over girin:",
      Overs: "Over",
      Restart: "Yeniden başlat",
      "Set Number of Overs": "Over sayısını ayarla",
      "How many overs will this match have?": "Bu maçta kaç over olacak?",
      "Set Overs": "Over ayarla",
      "Target Ready!": "Hedef hazır!",
      needs: "ihtiyacı var",
      "runs to win": "kazanmaya kalan run",
      "First innings complete. Start the chase when you’re ready.":
        "İlk devre tamamlandı. Hazır olduğunda kovalamaya başla.",
      "Begin Chase": "Kovalamaya başla",
    },
  },
  gu: {
    translation: {
      "has clinched victory! Celebrate the win and share the result.": "એ વિજય હાંસલ કર્યો છે! વિજયનો ઉત્સવ મનાવો અને પરિણામ શેર કરો.",
      "Both teams are tied. Get ready for a thrilling super over to decide the champion!": "બંને ટીમ્સ બરાબર છે. ચેમ્પિયન નક્કી કરવા માટે રોમાંચક સુપર ઓવર માટે તૈયાર થાઓ!",
      "Finish Game": "ગેમ પૂર્ણ કરો",
      "Start Super Over": "સુપર ઓવર શરૂ કરો",
      "Innings Breakdown": "ઇનિંગ્સનું વિભાજન",
      "No events for this team yet.": "આ ટીમ માટે હજુ સુધી કોઈ ઇવેન્ટ નથી.",
      // Home page
      "Home": "હોમ",
      "Cricket Score Counter – Free Online Live Score Tracker": "ક્રિકેટ સ્કોર કાઉન્ટર – મફત ઓનલાઈન લાઈવ સ્કોર ટ્રેકર",
      "Effortlessly count runs, track overs, and share live cricket scores with friends. Perfect for street, club, or school matches – keep your game organized and scores accessible from any device, anywhere.": "સરળતાથી રન ગણો, ઓવર્સ ટ્રેક કરો, અને મિત્રો સાથે લાઈવ ક્રિકેટ સ્કોર શેર કરો. ગલી, ક્લબ, અથવા સ્કૂલ મેચ માટે પરફેક્ટ – તમારો ગેમ ઓર્ગેનાઈઝ રાખો અને સ્કોર કોઈપણ ડિવાઈસ પરથી, ક્યાંયથી પણ એક્સેસ કરો.",
      // Footer
      "Cricket Score Counter. All rights reserved.": "ક્રિકેટ સ્કોર કાઉન્ટર. સર્વાધિકાર સુરક્ષિત.",
      "This site uses cookies and may serve ads by Google AdSense. By using this site, you agree to our policies.": "આ સાઇટ કૂકીઝનો ઉપયોગ કરે છે અને Google AdSense દ્વારા જાહેરાતો બતાવી શકે છે. આ સાઇટનો ઉપયોગ કરીને, તમે અમારી નીતિઓથી સંમત છો.",
      // Disclaimer page
      "Disclaimer": "અસ્વીકરણ",
      "Disclaimer for Cricket Score Counter.": "ક્રિકેટ સ્કોર કાઉન્ટર માટે અસ્વીકરણ.",
      "Cricket Score Counter is provided for informational and entertainment purposes only. We do not guarantee the accuracy or completeness of scores or match data.": "ક્રિકેટ સ્કોર કાઉન્ટર માત્ર માહિતી અને મનોરંજન માટે આપવામાં આવે છે. અમે સ્કોર અથવા મેચ ડેટાની ચોકસાઈ અથવા પૂર્ણતાની ખાતરી આપતા નથી.",
      "Ads and Third-Party Content": "જાહેરાતો અને તૃતીય પક્ષની સામગ્રી",
      "This site may display ads served by Google AdSense. We are not responsible for the content of third-party ads or external links.": "આ સાઇટ Google AdSense દ્વારા આપવામાં આવેલી જાહેરાતો બતાવી શકે છે. અમે તૃતીય પક્ષની જાહેરાતો અથવા બાહ્ય લિંક્સની સામગ્રી માટે જવાબદાર નથી.",
      "Limitation of Liability": "જવાબદારીની મર્યાદા",
      "We are not liable for any damages resulting from the use of this site.": "આ સાઇટના ઉપયોગથી થતા કોઈપણ નુકસાન માટે અમે જવાબદાર નથી.",
      // Privacy Policy page
      "Privacy Policy": "ગોપનીયતા નીતિ",
      "Privacy Policy for Cricket Score Counter.": "ક્રિકેટ સ્કોર કાઉન્ટર માટે ગોપનીયતા નીતિ.",
      "This Privacy Policy explains how Cricket Score Counter collects, uses, and protects your information.": "આ ગોપનીયતા નીતિ સમજાવે છે કે ક્રિકેટ સ્કોર કાઉન્ટર તમારી માહિતી કેવી રીતે એકત્રિત કરે છે, ઉપયોગ કરે છે અને સુરક્ષિત રાખે છે.",
      "Information Collection": "માહિતી એકત્રિત કરવી",
      "We may collect non-personal information such as browser type, device, and usage statistics. We do not collect personal information unless you provide it voluntarily.": "અમે બ્રાઉઝર પ્રકાર, ડિવાઇસ અને ઉપયોગના આંકડા જેવી વ્યક્તિગત ન હોય તેવી માહિતી એકત્રિત કરી શકીએ છીએ. અમે વ્યક્તિગત માહિતી એકત્રિત કરતા નથી, જો તમે સ્વેચ્છાએ આપો નહીં તો.",
      "Cookies and Ads": "કૂકીઝ અને જાહેરાતો",
      "We use cookies to improve your experience. We may serve ads by Google AdSense, which may use cookies to personalize ads.": "અમે તમારા અનુભવને સુધારવા માટે કૂકીઝનો ઉપયોગ કરીએ છીએ. અમે Google AdSense દ્વારા જાહેરાતો આપી શકીએ છીએ, જે જાહેરાતોને વ્યક્તિગત બનાવવા માટે કૂકીઝનો ઉપયોગ કરી શકે છે.",
      "Third-Party Services": "ત્રીજા પક્ષની સેવાઓ",
      "We may use third-party services such as Google Analytics and AdSense. These services may collect and use information according to their own policies.": "અમે Google Analytics અને AdSense જેવી ત્રીજા પક્ષની સેવાઓનો ઉપયોગ કરી શકીએ છીએ. આ સેવાઓ તેમની પોતાની નીતિઓ અનુસાર માહિતી એકત્રિત અને ઉપયોગ કરી શકે છે.",
      "Your Consent": "તમારી સંમતિ",
      "By using our site, you consent to our privacy policy.": "અમારી સાઇટનો ઉપયોગ કરીને, તમે અમારી ગોપનીયતા નીતિ માટે સંમતિ આપો છો.",
      "Contact": "સંપર્ક કરો",
      "If you have questions, contact us at": "જો તમને પ્રશ્નો હોય, તો અમારો સંપર્ક કરો",
      Welcome: "સ્વાગત છે",
      "Create Game": "ગેમ બનાવો",
      "Join Game": "ગેમમાં જોડાઓ",
      "Score Board": "સ્કોર બોર્ડ",
      "Cricket Score Counter": "ક્રિકેટ સ્કોર કાઉન્ટર",
      "The easiest way to score, track, and share your cricket matches live.":
        "તમારા ક્રિકેટ મેચને લાઈવ સ્કોર, ટ્રેક અને શેર કરવાની સૌથી સરળ રીત.",
      "Start a new match or join an existing one to begin scoring instantly.":
        "નવું મેચ શરૂ કરો અથવા પહેલાથી જ કોઈમાં જોડાઓ અને તરત સ્કોરિંગ શરૂ કરો.",
      "Quick Match Setup": "ઝડપી મેચ સેટઅપ",
      "Start a new game in seconds—no sign up needed!":
        "સેકન્ડોમાં નવું ગેમ શરૂ કરો—સાઇન અપની જરૂર નથી!",
      "Real-Time Scoring": "રિયલ-ટાઈમ સ્કોરિંગ",
      "Update scores ball-by-ball and see instant results.":
        "દર બૉલ પછી સ્કોર અપડેટ કરો અને તરત પરિણામ જુઓ.",
      "Easy Sharing": "સહેલાઈથી શેર કરો",
      "Share your match link with friends and family instantly.":
        "તમારા મેચનો લિંક તરત જ મિત્રો અને પરિવાર સાથે શેર કરો.",
      "Enter Game ID": "ગેમ ID દાખલ કરો",
      "Game ID": "ગેમ ID",
      "Game ID is required": "ગેમ ID જરૂરી છે",
      Cancel: "રદ કરો",
      "View Score": "સ્કોર જુઓ",
      "Team 1 Name": "ટીમ 1 નામ",
      "Team 2 Name": "ટીમ 2 નામ",
      "Number of Overs": "ઓવર્સની સંખ્યા",
      "Please enter both team names.": "કૃપા કરીને બંને ટીમના નામ દાખલ કરો.",
      "Please enter a valid number of overs (1-50).":
        "કૃપા કરીને માન્ય ઓવર્સની સંખ્યા (1-50) દાખલ કરો.",
      "Enter Team Names": "ટીમના નામ દાખલ કરો",
      "INDIA A": "ભારત A",
      "INDIA B": "ભારત B",
      "Team 1": "ટીમ 1",
      "Team 2": "ટીમ 2",
      "will flip the coin": "સિક્કો ઉછાળશે",
      "will select Heads or Tails": "હેડ્સ અથવા ટેલ્સ પસંદ કરશે",
      Heads: "હેડ્સ",
      Tails: "ટેલ્સ",
      "Select Heads or Tails first": "પહેલાં હેડ્સ અથવા ટેલ્સ પસંદ કરો",
      "Click to flip coin": "સિક્કો ઉછાળવા માટે ક્લિક કરો",
      "Tap the coin to flip": "સિક્કો ઉછાળવા માટે ટૅપ કરો",
      "Select Heads or Tails to enable coin":
        "સિક્કો સક્રિય કરવા માટે હેડ્સ અથવા ટેલ્સ પસંદ કરો",
      "Coin Flip Result:": "સિક્કો ઉછાળવાનો પરિણામ:",
      "won the toss!": "ટોસ જીતી!",
      "Bat First": "પહેલાં બેટિંગ",
      "Ball First": "પહેલાં બોલિંગ",
      "Start Match": "મેચ શરૂ કરો",
      "Go with Toss": "ટોસ સાથે જાઓ",
      "Copy Game ID": "ગેમ ID કૉપિ કરો",
      "Share Game": "ગેમ શેર કરો",
      "End Inning": "ઇનિંગ પૂર્ણ કરો",
      "End Game": "ગેમ પૂર્ણ કરો",
      "View History": "ઇતિહાસ જુઓ",
      "Reset Game": "ગેમ રીસેટ કરો",
      "Game ID copied!": "ગેમ ID કૉપિ થઈ ગયું!",
      "End Inning?": "ઇનિંગ પૂર્ણ કરો?",
      "End Game?": "ગેમ પૂર્ણ કરો?",
      "Are you sure you want to end the current inning? This action cannot be undone.":
        "શું તમે ખરેખર વર્તમાન ઇનિંગ પૂર્ણ કરવા માંગો છો? આ ક્રિયા પાછી ફરી શકશે નહીં.",
      "Are you sure you want to end the game? This will reset all progress.":
        "શું તમે ખરેખર ગેમ પૂર્ણ કરવા માંગો છો? આથી તમામ પ્રગતિ રીસેટ થઈ જશે.",
      Yes: "હા",
      "Congratulations!": "અભિનંદન!",
      "wins the match!": "મેચ જીતી ગયો!",
      "It's a Tie! Super Over Time!": "ટાઈ! સુપર ઓવર!",
      "Restart Match?": "મેચ ફરી શરૂ કરશો?",
      "This will clear your current match.":
        "આ તમારા વર્તમાન મેચને સાફ કરી દેશે.",
      "Enter overs for the new match:": "નવા મેચ માટે ઓવર્સ દાખલ કરો:",
      Overs: "ઓવર્સ",
      Restart: "ફરી શરૂ કરો",
      "Set Number of Overs": "ઓવર્સની સંખ્યા સેટ કરો",
      "How many overs will this match have?": "આ મેચમાં કેટલા ઓવર્સ હશે?",
      "Set Overs": "ઓવર્સ સેટ કરો",
      "Target Ready!": "લક્ષ્ય તૈયાર!",
      needs: "જરૂર છે",
      "runs to win": "જીતવા માટે રન",
      "First innings complete. Start the chase when you’re ready.":
        "પ્રથમ ઇનિંગ્સ પૂર્ણ. તમે તૈયાર હો ત્યારે ચેઝ શરૂ કરો.",
      "Begin Chase": "ચેઝ શરૂ કરો",
    },
  },
  nl: {
    translation: {
      "has clinched victory! Celebrate the win and share the result.": "heeft de overwinning behaald! Vier de overwinning en deel het resultaat.",
      "Both teams are tied. Get ready for a thrilling super over to decide the champion!": "Beide teams staan gelijk. Maak je klaar voor een spannende super over om de kampioen te bepalen!",
      "Finish Game": "Wedstrijd beëindigen",
      "Start Super Over": "Start Super Over",
      "Innings Breakdown": "Overzicht van innings",
      "No events for this team yet.": "Nog geen evenementen voor dit team.",
      // Home page
      "Home": "Home",
      "Cricket Score Counter – Free Online Live Score Tracker": "Cricket Score Counter – Gratis Online Live Score Tracker",
      "Effortlessly count runs, track overs, and share live cricket scores with friends. Perfect for street, club, or school matches – keep your game organized and scores accessible from any device, anywhere.": "Tel moeiteloos runs, houd overs bij en deel live cricket scores met vrienden. Perfect voor straat-, club- of schoolwedstrijden – houd je spel georganiseerd en scores toegankelijk vanaf elk apparaat, overal.",
      // Footer
      "Cricket Score Counter. All rights reserved.": "Cricket Score Counter. Alle rechten voorbehouden.",
      "This site uses cookies and may serve ads by Google AdSense. By using this site, you agree to our policies.": "Deze site gebruikt cookies en kan advertenties van Google AdSense tonen. Door deze site te gebruiken, gaat u akkoord met ons beleid.",
      // Disclaimer page
      "Disclaimer": "Disclaimer",
      "Disclaimer for Cricket Score Counter.": "Disclaimer voor Cricket Score Counter.",
      "Cricket Score Counter is provided for informational and entertainment purposes only. We do not guarantee the accuracy or completeness of scores or match data.": "Cricket Score Counter wordt alleen verstrekt voor informatieve en entertainmentdoeleinden. We garanderen niet de nauwkeurigheid of volledigheid van scores of wedstrijddata.",
      "Ads and Third-Party Content": "Advertenties en inhoud van derden",
      "This site may display ads served by Google AdSense. We are not responsible for the content of third-party ads or external links.": "Deze site kan advertenties tonen die worden aangeboden door Google AdSense. Wij zijn niet verantwoordelijk voor de inhoud van advertenties van derden of externe links.",
      "Limitation of Liability": "Beperking van aansprakelijkheid",
      "We are not liable for any damages resulting from the use of this site.": "Wij zijn niet aansprakelijk voor enige schade die voortvloeit uit het gebruik van deze site.",
      // Privacy Policy page
      "Privacy Policy": "Privacybeleid",
      "Privacy Policy for Cricket Score Counter.": "Privacybeleid voor Cricket Score Counter.",
      "This Privacy Policy explains how Cricket Score Counter collects, uses, and protects your information.": "Dit privacybeleid legt uit hoe Cricket Score Counter uw informatie verzamelt, gebruikt en beschermt.",
      "Information Collection": "Informatie verzamelen",
      "We may collect non-personal information such as browser type, device, and usage statistics. We do not collect personal information unless you provide it voluntarily.": "We kunnen niet-persoonlijke informatie verzamelen, zoals browsertype, apparaat en gebruiksstatistieken. We verzamelen geen persoonlijke informatie tenzij u deze vrijwillig verstrekt.",
      "Cookies and Ads": "Cookies en advertenties",
      "We use cookies to improve your experience. We may serve ads by Google AdSense, which may use cookies to personalize ads.": "We gebruiken cookies om uw ervaring te verbeteren. We kunnen advertenties van Google AdSense tonen, die cookies kunnen gebruiken om advertenties te personaliseren.",
      "Third-Party Services": "Diensten van derden",
      "We may use third-party services such as Google Analytics and AdSense. These services may collect and use information according to their own policies.": "We kunnen diensten van derden gebruiken, zoals Google Analytics en AdSense. Deze diensten kunnen informatie verzamelen en gebruiken volgens hun eigen beleid.",
      "Your Consent": "Uw toestemming",
      "By using our site, you consent to our privacy policy.": "Door onze site te gebruiken, stemt u in met ons privacybeleid.",
      "Contact": "Contact",
      "If you have questions, contact us at": "Als u vragen heeft, neem dan contact met ons op via",
      Welcome: "Welkom",
      "Create Game": "Spel aanmaken",
      "Join Game": "Deelnemen aan spel",
      "Score Board": "Scorebord",
      "Cricket Score Counter": "Cricket Score Teller",
      "The easiest way to score, track, and share your cricket matches live.":
        "De makkelijkste manier om je cricketwedstrijden live te scoren, volgen en delen.",
      "Start a new match or join an existing one to begin scoring instantly.":
        "Start een nieuwe wedstrijd of neem deel aan een bestaande om direct te scoren.",
      "Quick Match Setup": "Snelle wedstrijdinstelling",
      "Start a new game in seconds—no sign up needed!":
        "Start een nieuw spel in seconden—geen registratie nodig!",
      "Real-Time Scoring": "Live score",
      "Update scores ball-by-ball and see instant results.":
        "Werk scores bal voor bal bij en zie direct resultaat.",
      "Easy Sharing": "Gemakkelijk delen",
      "Share your match link with friends and family instantly.":
        "Deel direct je wedstrijdlink met vrienden en familie.",
      "Enter Game ID": "Voer spel-ID in",
      "Game ID": "Spel-ID",
      "Game ID is required": "Spel-ID is verplicht",
      Cancel: "Annuleren",
      "View Score": "Score bekijken",
      "Team 1 Name": "Team 1 naam",
      "Team 2 Name": "Team 2 naam",
      "Number of Overs": "Aantal overs",
      "Please enter both team names.": "Voer beide teamnamen in.",
      "Please enter a valid number of overs (1-50).":
        "Voer een geldig aantal overs in (1-50).",
      "Enter Team Names": "Voer teamnamen in",
      "INDIA A": "INDIA A",
      "INDIA B": "INDIA B",
      "Team 1": "Team 1",
      "Team 2": "Team 2",
      "will flip the coin": "zal de munt opgooien",
      "will select Heads or Tails": "zal kop of munt kiezen",
      Heads: "Kop",
      Tails: "Munt",
      "Select Heads or Tails first": "Kies eerst kop of munt",
      "Click to flip coin": "Klik om de munt op te gooien",
      "Tap the coin to flip": "Tik op de munt om op te gooien",
      "Select Heads or Tails to enable coin":
        "Kies kop of munt om de munt te activeren",
      "Coin Flip Result:": "Resultaat van de muntworp:",
      "won the toss!": "won de toss!",
      "Bat First": "Eerst slaan",
      "Ball First": "Eerst gooien",
      "Start Match": "Wedstrijd starten",
      "Go with Toss": "Begin met toss",
      "Copy Game ID": "Spel-ID kopiëren",
      "Share Game": "Spel delen",
      "End Inning": "Inning beëindigen",
      "End Game": "Spel beëindigen",
      "View History": "Geschiedenis bekijken",
      "Reset Game": "Spel resetten",
      "Game ID copied!": "Spel-ID gekopieerd!",
      "End Inning?": "Inning beëindigen?",
      "End Game?": "Spel beëindigen?",
      "Are you sure you want to end the current inning? This action cannot be undone.":
        "Weet je zeker dat je de huidige inning wilt beëindigen? Deze actie kan niet ongedaan worden gemaakt.",
      "Are you sure you want to end the game? This will reset all progress.":
        "Weet je zeker dat je het spel wilt beëindigen? Alle voortgang wordt gereset.",
      Yes: "Ja",
      "Congratulations!": "Gefeliciteerd!",
      "wins the match!": "wint de wedstrijd!",
      "It's a Tie! Super Over Time!": "Gelijkspel! Super Over!",
      "Restart Match?": "Wedstrijd opnieuw starten?",
      "This will clear your current match.": "Dit wist je huidige wedstrijd.",
      "Enter overs for the new match:":
        "Voer het aantal overs in voor de nieuwe wedstrijd:",
      Overs: "Overs",
      Restart: "Opnieuw starten",
      "Set Number of Overs": "Aantal overs instellen",
      "How many overs will this match have?":
        "Hoeveel overs heeft deze wedstrijd?",
      "Set Overs": "Overs instellen",
      "Target Ready!": "Doel klaar!",
      needs: "heeft nodig",
      "runs to win": "runs om te winnen",
      "First innings complete. Start the chase when you’re ready.":
        "Eerste innings voltooid. Begin de achtervolging wanneer je klaar bent.",
      "Begin Chase": "Achtervolging beginnen",
    },
  },
};

const englishTranslation = resources.en.translation as Record<string, string>;
const additionalEnglishKeys = [
  "Player Scorecard",
  "Scorecard",
  "Player Preferences",
  "Manage Players",
  "Change Bowler",
  "Select Opening Players",
  "Batting",
  "Bowling",
  "Opening Striker",
  "Opening Non-Striker",
  "Opening Bowler",
  "Please select striker, non-striker and bowler. Striker and non-striker must be different.",
  "Start Scoring",
  "Select Next Bowler",
  "Over completed. Choose bowler for next over.",
  "No eligible bowler available. Previous over bowler cannot bowl consecutive overs.",
  "Please select a bowler.",
  "Same bowler cannot bowl the next over.",
  "Confirm",
  "Wicket Details",
  "Which batsman is out?",
  "Wicket type",
  "Bowled",
  "Catch",
  "Run Out",
  "Caught by {{name}}",
  "Run out by {{name}}",
  "Select new batsman",
  "No available incoming batsman left.",
  "Please complete wicket details. Striker/non-striker replacement must be valid.",
  "Continue",
  "Status",
  "out",
  "Not out",
  "Players",
  "Add player",
  "Add",
  "1st Inning",
  "2nd Inning",
  "Track individual match stats (batting and bowling) for this match only.",
  "Close",
  "Done",
  "Team 1 Players",
  "Team 2 Players",
  "Add Players",
  "No saved players found for {{team}}. Please add at least {{count}} players.",
  "Player name is required.",
  "Player already exists.",
  "How to Set Up Your Cricket Match:",
  "Enter unique team names for both sides.",
  "Choose the number of overs (1-50) for your match.",
  "Optionally, use the toss feature to decide who bats or bowls first.",
  "Click \"Start Match\" to begin scoring live.",
  "Cricket Match FAQ:",
  "What is an over?",
  "An over consists of 6 legal balls bowled by one bowler.",
  "How do I score runs?",
  "Use the scoring keypad to add runs, wickets, and extras ball-by-ball.",
  "Can I share my match?",
  "Yes! After setup, use the share link to invite friends and family.",
  "Is my data private?",
  "Your scores are only visible to those with your match link.",
  "Need help?",
  "Next",
  "Enter player name",
  "Please add at least {{count}} players for each team.",
  "W",
  "WD",
  "NB",
  "More",
  "Undo",
  "Wide + {{runs}} runs",
  "3 runs",
  "Run Out + 1 run",
  "Run Out + 2 runs",
  "Run Out + 3 runs",
  "ON STRIKE",
  "CURRENT BOWLER",
  "R",
  "B",
  "O",
  "SR",
  "Econ",
  "runs needed in",
  "overs",
  "CRR",
  "RRR",
  "Over",
  "Runs",
  "Wickets",
  "{{team}} (team)",
  "Team bowling",
  "Match history",
  "shows all runs, wickets, and events for each over. Use it to review performance, analyze key moments, or settle disputes.",
  "What is match history?",
  "Match history shows all runs, wickets, and events for each over.",
  "Reviewing history helps teams analyze performance and key moments.",
  "Use this feature to settle disputes or relive exciting plays!",
  "Match History",
  "Please enter a valid Game ID.",
  "View live cricket scores and match details. Join a game and follow the action with Cricket Score Counter.",
  "Join Live Cricket Match",
  "Join a live cricket match with Game ID and follow ball-by-ball score updates, wickets, overs, and match momentum in real time.",
  "Enter your Game ID below to join a live cricket match and view scores in real time.",
  "How to Join a Cricket Match:",
  "Ask your friend or match organizer for the Game ID.",
  "Enter the Game ID above and click \"Join\".",
  "View live scores, match stats, and recent events instantly.",
  "Share the match link with others to let them follow along.",
  "Contact Support",
  "Join",
  "Page Not Found",
  "Sorry, the page you are looking for does not exist.",
  "Please check the URL or return to the home page.",
  "About Cricket Score Counter:",
  "Track live cricket scores for any match, anywhere.",
  "Set up your own match, invite friends, and keep score ball-by-ball.",
  "Perfect for street, club, or school games.",
  "Learn more in our",
  "and",
  "or",
  "return to the home page",
  "Read the Cricket Score Counter privacy policy, including cookies, analytics, ads, and data usage details.",
  "Read the Cricket Score Counter disclaimer about score accuracy, third-party ads, and liability limits.",
  "Detailed scorecard is not available for this match.",
  "Game link copied to clipboard!",
  "Error copying game link. Please copy manually: ",
  "Target score",
  "The runs the chasing team must reach to win, set after the first team bats. The chasing team must score at least one more run than the target.",
  "Match winner",
  "The team with the most runs at the end wins. If scores are tied, the match may be a tie or go to a super over.",
  "No-ball",
  "An illegal delivery (like overstepping or dangerous bowling). The batting team gets an extra run and a free hit next ball.",
  "No-Ball: Add Runs",
  "Resetting the score",
  "lets you start a new match or fix mistakes. All previous runs, wickets, and overs will be cleared. This action cannot be undone.",
  "Share your match",
  "Copy the link and send it to friends or family. Anyone with the link can view live scores and match details in real time.",
  "Share Game Link",
  "Copied!",
  "Copy Link",
  "Failed to copy link. Please copy manually.",
] as const;

additionalEnglishKeys.forEach((key) => {
  if (!englishTranslation[key]) {
    englishTranslation[key] = key;
  }
});

(Object.keys(resources) as Array<keyof typeof resources>).forEach((lang) => {
  if (lang === "en") return;
  const localeTranslation = resources[lang].translation as Record<string, string>;
  resources[lang].translation = {
    ...englishTranslation,
    ...localeTranslation,
  } as any;
});

// The language picker was removed because most languages are only partly
// translated. Everyone now gets English; clear any language saved by the old
// picker so people who chose another language aren't stuck with it.
try {
  localStorage.removeItem("selectedLang");
} catch {
  // Storage can be blocked in some privacy modes; English is used anyway.
}
i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
